/** VERSION: 1.8.41.**/
/** Please don't modify or unzip this content. It will be updated regularly **/
var BoostOTP = (function (t) {
  var e = {};
  function n(i) {
    if (e[i]) return e[i].exports;
    var r = (e[i] = { i: i, l: !1, exports: {} });
    return t[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
  }
  return (
    (n.m = t),
    (n.c = e),
    (n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
    }),
    (n.r = function (t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (n.t = function (t, e) {
      if ((1 & e && (t = n(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (
        (n.r(i),
        Object.defineProperty(i, 'default', { enumerable: !0, value: t }),
        2 & e && 'string' != typeof t)
      )
        for (var r in t)
          n.d(
            i,
            r,
            function (e) {
              return t[e];
            }.bind(null, r)
          );
      return i;
    }),
    (n.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return n.d(e, 'a', e), e;
    }),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.p = ''),
    n((n.s = 107))
  );
})([
  function (t, e, n) {
    (function (e) {
      var n = function (t) {
        return t && t.Math == Math && t;
      };
      t.exports =
        n('object' == typeof globalThis && globalThis) ||
        n('object' == typeof window && window) ||
        n('object' == typeof self && self) ||
        n('object' == typeof e && e) ||
        Function('return this')();
    }.call(this, n(109)));
  },
  function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  },
  function (t, e, n) {
    var i = n(0),
      r = n(56),
      o = n(6),
      a = n(57),
      s = n(63),
      c = n(80),
      l = r('wks'),
      u = i.Symbol,
      f = c ? u : (u && u.withoutSetter) || a;
    t.exports = function (t) {
      return (
        o(l, t) || (s && o(u, t) ? (l[t] = u[t]) : (l[t] = f('Symbol.' + t))),
        l[t]
      );
    };
  },
  function (t, e, n) {
    var i = n(0),
      r = n(38).f,
      o = n(10),
      a = n(12),
      s = n(54),
      c = n(73),
      l = n(77);
    t.exports = function (t, e) {
      var n,
        u,
        f,
        p,
        d,
        h = t.target,
        v = t.global,
        m = t.stat;
      if ((n = v ? i : m ? i[h] || s(h, {}) : (i[h] || {}).prototype))
        for (u in e) {
          if (
            ((p = e[u]),
            (f = t.noTargetGet ? (d = r(n, u)) && d.value : n[u]),
            !l(v ? u : h + (m ? '.' : '#') + u, t.forced) && void 0 !== f)
          ) {
            if (typeof p == typeof f) continue;
            c(p, f);
          }
          (t.sham || (f && f.sham)) && o(p, 'sham', !0), a(n, u, p, t);
        }
    };
  },
  function (t, e, n) {
    var i = n(5);
    t.exports = function (t) {
      if (!i(t)) throw TypeError(String(t) + ' is not an object');
      return t;
    };
  },
  function (t, e) {
    t.exports = function (t) {
      return 'object' == typeof t ? null !== t : 'function' == typeof t;
    };
  },
  function (t, e) {
    var n = {}.hasOwnProperty;
    t.exports = function (t, e) {
      return n.call(t, e);
    };
  },
  function (t, e, n) {
    'use strict';
    n(115), n(116), n(45), n(15), n(46);
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    var r = (function () {
      function t() {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError('Cannot call a class as a function');
        })(this, t),
          (this.isInit = !1),
          (this.isRendered = !1),
          (this.isBoundEvent = !1),
          (this.children = []),
          (this.parent = null),
          (this.$element = null);
      }
      var e, n, r;
      return (
        (e = t),
        (n = [
          {
            key: 'refresh',
            value: function () {
              this._callAllInit(),
                this._callAllRender(),
                this._callAllBindEvents();
            },
          },
          { key: 'beforeInit', value: function () {} },
          { key: 'init', value: function () {} },
          { key: 'afterInit', value: function () {} },
          {
            key: 'isLoopThroughChild',
            value: function () {
              return !0;
            },
          },
          {
            key: 'isRender',
            value: function () {
              return !0;
            },
          },
          { key: 'beforeRender', value: function () {} },
          { key: 'render', value: function () {} },
          { key: 'afterRender', value: function () {} },
          {
            key: 'isBindEvents',
            value: function () {
              return !0;
            },
          },
          { key: 'beforeBindEvents', value: function () {} },
          { key: 'bindEvents', value: function () {} },
          { key: 'afterBindEvents', value: function () {} },
          {
            key: 'addComponent',
            value: function (t) {
              (t.parent = this), this.children.push(t);
            },
          },
          {
            key: 'removeComponent',
            value: function (t) {
              if (this.children && this.children.length > 0) {
                var e = this.children.indexOf(t);
                -1 !== e && this.children.splice(e, 1);
              }
            },
          },
          {
            key: '_callAllInit',
            value: function () {
              this.isInit || (this.beforeInit(), this.init()),
                this.children &&
                  this.children.length > 0 &&
                  this.isLoopThroughChild() &&
                  this.children.forEach(function (t) {
                    t._callAllInit();
                  }),
                this.isInit || (this.afterInit(), (this.isInit = !0));
            },
          },
          {
            key: '_callAllRender',
            value: function () {
              this.isRender() && this.beforeRender(),
                this.children &&
                  this.children.length > 0 &&
                  this.isLoopThroughChild() &&
                  this.children.forEach(function (t) {
                    t._callAllRender();
                  }),
                this.isRender() &&
                  (this.render(), this.afterRender(), (this.isRendered = !0));
            },
          },
          {
            key: '_callAllBindEvents',
            value: function () {
              this.isBindEvents() && this.beforeBindEvents(),
                this.children &&
                  this.children.length > 0 &&
                  this.isLoopThroughChild() &&
                  this.children.forEach(function (t) {
                    t._callAllBindEvents();
                  }),
                this.isBindEvents() &&
                  (this.bindEvents(),
                  this.afterBindEvents(),
                  (this.isBoundEvent = !0));
            },
          },
        ]) && i(e.prototype, n),
        r && i(e, r),
        t
      );
    })();
    e.a = r;
  },
  function (t, e, n) {
    var i = n(1);
    t.exports = !i(function () {
      return (
        7 !=
        Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          },
        })[1]
      );
    });
  },
  function (t, e, n) {
    var i = n(8),
      r = n(71),
      o = n(4),
      a = n(39),
      s = Object.defineProperty;
    e.f = i
      ? s
      : function (t, e, n) {
          if ((o(t), (e = a(e, !0)), o(n), r))
            try {
              return s(t, e, n);
            } catch (t) {}
          if ('get' in n || 'set' in n)
            throw TypeError('Accessors not supported');
          return 'value' in n && (t[e] = n.value), t;
        };
  },
  function (t, e, n) {
    var i = n(8),
      r = n(9),
      o = n(24);
    t.exports = i
      ? function (t, e, n) {
          return r.f(t, e, o(1, n));
        }
      : function (t, e, n) {
          return (t[e] = n), t;
        };
  },
  function (t, e) {
    var n = {}.toString;
    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  },
  function (t, e, n) {
    var i = n(0),
      r = n(10),
      o = n(6),
      a = n(54),
      s = n(55),
      c = n(25),
      l = c.get,
      u = c.enforce,
      f = String(String).split('String');
    (t.exports = function (t, e, n, s) {
      var c = !!s && !!s.unsafe,
        l = !!s && !!s.enumerable,
        p = !!s && !!s.noTargetGet;
      'function' == typeof n &&
        ('string' != typeof e || o(n, 'name') || r(n, 'name', e),
        (u(n).source = f.join('string' == typeof e ? e : ''))),
        t !== i
          ? (c ? !p && t[e] && (l = !0) : delete t[e],
            l ? (t[e] = n) : r(t, e, n))
          : l
          ? (t[e] = n)
          : a(e, n);
    })(Function.prototype, 'toString', function () {
      return ('function' == typeof this && l(this).source) || s(this);
    });
  },
  function (t, e, n) {
    var i = n(74),
      r = n(0),
      o = function (t) {
        return 'function' == typeof t ? t : void 0;
      };
    t.exports = function (t, e) {
      return arguments.length < 2
        ? o(i[t]) || o(r[t])
        : (i[t] && i[t][e]) || (r[t] && r[t][e]);
    };
  },
  function (t, e, n) {
    var i = n(19);
    t.exports = function (t) {
      return Object(i(t));
    };
  },
  function (t, e, n) {
    var i = n(66),
      r = n(12),
      o = n(113);
    i || r(Object.prototype, 'toString', o, { unsafe: !0 });
  },
  function (t, e, n) {
    'use strict';
    n.r(e);
    n(47),
      n(28),
      n(49),
      n(17),
      n(15),
      n(45),
      n(46),
      n(102),
      n(138),
      n(84),
      n(32),
      n(33),
      n(29),
      n(30),
      n(31),
      n(34),
      n(23),
      n(36),
      n(37);
    var i = n(7),
      r = n(70);
    function o(t) {
      return (o =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            })(t);
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError('Cannot call a class as a function');
    }
    function s(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function c(t, e) {
      return (c =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function l(t, e) {
      return !e || ('object' !== o(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t)
        : e;
    }
    function u(t) {
      return (u = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var f = BoostPFS.jQ,
      p = BoostPFS.Labels,
      d = BoostPFS.Utils,
      h = BoostPFS.Selector,
      v = null,
      m = (function (t) {
        !(function (t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError(
              'Super expression must either be null or a function'
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && c(t, e);
        })(m, t);
        var e,
          n,
          i,
          o = (function (t) {
            function e() {
              if ('undefined' == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ('function' == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = u(t);
              if (e()) {
                var r = u(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return l(this, n);
            };
          })(m);
        function m() {
          return a(this, m), o.apply(this, arguments);
        }
        return (
          (e = m),
          (i = [
            {
              key: 'instance',
              get: function () {
                return v;
              },
            },
          ]),
          (n = [
            {
              key: 'init',
              value: function () {
                (this.isFetchedCartData = !1),
                  (v = this),
                  this.initActions(),
                  this.getCart();
              },
            },
            {
              key: 'getTemplate',
              value: function () {
                return '\n\t\t\t<div class="boost-pfs-minicart-wrapper boost-pfs-minicart-{{ajaxCartStyle}}-wrapper">\n\t\t\t\t<div class="boost-pfs-minicart-backdrop"></div>\n\t\t\t\t<div class="boost-pfs-minicart-container boost-pfs-minicart-container-{{ajaxCartStyle}}">\n\t\t\t\t\t<div class="boost-pfs-minicart-container-inner">\n\t\t\t\t\t\t<div class="boost-pfs-minicart-heading">\n\t\t\t\t\t\t\t<h3 class="boost-pfs-minicart-title">{{label.atcMiniCartShopingCartLabel}} (<span class="boost-pfs-count-item">{{countItem}}</span><span class="boost-pfs-count-item-label">{{label.atcMiniCartCountItemLabel}}</span>)</h3>\n\t\t\t\t\t\t\t<span title="Clear All" class="boost-pfs-minicart-clear-all">{{label.clearAll}}</span>\n\t\t\t\t\t\t\t<span title="Close" class="boost-pfs-minicart-close"><span class="boost-pfs-minicart-close-text">{{label.close}}</span></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="boost-pfs-minicart-content">\n\t\t\t\t\t\t\t<div class="boost-pfs-minicart-top">\n\t\t\t\t\t\t\t\t<div class="boost-pfs-minicart-empty">{{label.atcMiniCartEmptyCartLabel}}</div>\n\t\t\t\t\t\t\t\t<ol>{{cartItems}}</ol>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="boost-pfs-minicart-bottom">\n\t\t\t\t\t\t\t\t<div class="boost-pfs-subtotal">\n\t\t\t\t\t\t\t\t\t<span class="boost-pfs-subtotal-label">{{label.atcMiniCartSubtotalLabel}}</span>\n\t\t\t\t\t\t\t\t\t<span class="boost-pfs-subtotal-price">{{subtotalPrice}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="boost-pfs-checkout-action">\n\t\t\t\t\t\t\t\t\t<div class="boost-pfs-checkout">\n\t\t\t\t\t\t\t\t\t\t<a href="/checkout" class="boost-pfs-checkout-btn">{{label.atcMiniCartCheckoutLabel}}</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="boost-pfs-viewcart">\n\t\t\t\t\t\t\t\t\t\t<a href="/cart">{{label.atcMiniCartViewCartLabel}}</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
              },
            },
            {
              key: 'compileTemplate',
              value: function () {
                var t = d.formatMoney(this.data.items_subtotal_price);
                return this.getTemplate()
                  .replace(/{{label.close}}/g, p.close)
                  .replace(/{{label.clearAll}}/g, p.clearAll)
                  .replace(
                    /{{label.atcMiniCartEmptyCartLabel}}/g,
                    p.action_list.atcMiniCartEmptyCartLabel
                  )
                  .replace(
                    /{{label.atcMiniCartShopingCartLabel}}/g,
                    p.action_list.atcMiniCartShopingCartLabel
                  )
                  .replace(
                    /{{label.atcMiniCartCountItemLabel}}/g,
                    p.action_list.atcMiniCartCountItemLabel
                  )
                  .replace(
                    /{{label.atcMiniCartCountItemLabelPlural}}/g,
                    p.action_list.atcMiniCartCountItemLabelPlural
                  )
                  .replace(
                    /{{label.atcMiniCartSubtotalLabel}}/g,
                    p.action_list.atcMiniCartSubtotalLabel
                  )
                  .replace(
                    /{{label.atcMiniCartCheckoutLabel}}/g,
                    p.action_list.atcMiniCartCheckoutLabel
                  )
                  .replace(
                    /{{label.atcMiniCartViewCartLabel}}/g,
                    p.action_list.atcMiniCartViewCartLabel
                  )
                  .replace(
                    /{{ajaxCartStyle}}/g,
                    Settings.getSettingValue('general.ajaxCartStyle')
                  )
                  .replace(/{{subtotalPrice}}/g, t)
                  .replace(/{{countItem}}/g, this.data.item_count)
                  .replace(/{{cartItems}}/g, '');
              },
            },
            {
              key: 'isRender',
              value: function () {
                return this.isFetchedCartData;
              },
            },
            {
              key: 'render',
              value: function () {
                var t = this;
                this.$element ||
                  ((this.$element = f(this.compileTemplate())),
                  f('body').append(this.$element)),
                  this.$element.find('.boost-pfs-minicart-top > ol').html(''),
                  this.cartItems.forEach(function (e) {
                    e.$element &&
                      t.$element
                        .find('.boost-pfs-minicart-top > ol')
                        .append(e.$element);
                  }),
                  0 == this.cartItems.length
                    ? (this.$element.find('.boost-pfs-minicart-empty').show(),
                      this.$element.find('.boost-pfs-minicart-bottom').hide(),
                      f('.boost-pfs-minicart-clear-all').hide())
                    : (this.$element.find('.boost-pfs-minicart-empty').hide(),
                      this.$element.find('.boost-pfs-minicart-bottom').show(),
                      this.clearCart()),
                  this.cartItems.length < 2
                    ? this.$element
                        .find('.boost-pfs-count-item-label')
                        .html(p.action_list.atcMiniCartCountItemLabel)
                    : this.$element
                        .find('.boost-pfs-count-item-label')
                        .html(p.action_list.atcMiniCartCountItemLabelPlural);
                var e = d.formatMoney(this.data.items_subtotal_price);
                this.$element.find('.boost-pfs-subtotal-price').html(e),
                  h.otpTopCartSubtotal &&
                    f(h.otpTopCartSubtotal).length > 0 &&
                    f(h.otpTopCartSubtotal).html(e);
                var n = f(h.otpTopCartCount).html() || '0';
                if (f(h.otpTopCartWrapper).length > 0 && '0' === n) {
                  var i =
                    '<div class="cart-count-bubble">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span aria-hidden="true">{{itemCount}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="visually-hidden">{{itemCount}}'.concat(
                      this.data.item_count > 1 ? 'items' : 'item',
                      '</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>'
                    );
                  f(h.otpTopCartWrapper).append(
                    i.replace(/{{itemCount}}/g, this.data.item_count)
                  );
                }
                this.updateTopCartCount(this.data.item_count);
                var r = this.$element.find('.boost-pfs-count-item').text();
                this.$element
                  .find('.boost-pfs-count-item')
                  .html(r.replace(/[0-9]+/, this.data.item_count));

                  console.log(this.data.item_count)
                    $('.header-counter-pill.mini-cart-total').text(this.data.item_count);
              },
            },
            {
              key: 'isBindEvents',
              value: function () {
                return this.isFetchedCartData;
              },
            },
            {
              key: 'bindEvents',
              value: function () {
                this.$element &&
                  (f(h.otpTopCartLink).on(
                    'click',
                    this.openAjaxCart.bind(this)
                  ),
                  f(
                    '.boost-pfs-minicart-backdrop, .boost-pfs-minicart-close'
                  ).on('click', this.closeAjaxCart.bind(this)),
                  f('.boost-pfs-viewcart, .boost-pfs-minicart-close').on(
                    'keydown',
                    this.trapFocus.bind(this)
                  ));
              },
            },
            {
              key: 'getCart',
              value: function (t) {
                var e = this;
                fetch('/cart.js', {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json' },
                })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (n) {
                    e.setData(n),
                      t
                        ? e.openAjaxCart()
                        : f('.boost-pfs-select-option-show').length > 0 &&
                          e.hideSelectOption();
                  });
              },
            },
            {
              key: 'addToCart',
              value: function (t, e, n, i) {
                var r = this,
                  o =
                    arguments.length > 4 &&
                    void 0 !== arguments[4] &&
                    arguments[4],
                  a = o
                    ? p.action_list.qvAddToCartBtnLabel
                    : p.action_list.atcAvailableLabel;
                this.changeButtonLabel(
                  n,
                  a,
                  p.action_list.atcAddingToCartBtnLabel
                );
                var s = { id: t.toString(), quantity: parseInt(e) };
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                  },
                  body: JSON.stringify(s),
                })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    null != t.status && 200 != t.status
                      ? r.onError(t, n, i, a)
                      : r.onSucess(t, n, i, a);
                  });
              },
            },
            {
              key: 'removeFromCart',
              value: function (t) {
                var e = this;
                fetch('/cart/change.js?quantity=0&id=' + t, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    null != t.status && 200 != t.status
                      ? e.onError(t)
                      : e.onSucess(t);
                  });
              },
            },
            {
              key: 'onSucess',
              value: function (t, e, n) {
                var i = this,
                  r =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : p.action_list.atcAvailableLabel;
                this.changeButtonLabel(
                  e,
                  p.action_list.atcAddingToCartBtnLabel,
                  p.action_list.atcAddedToCartBtnLabel
                ),
                  setTimeout(function () {
                    i.changeButtonLabel(
                      e,
                      p.action_list.atcAddedToCartBtnLabel,
                      r
                    );
                  }, 700);
                var o = Settings.getSettingValue('general.showAjaxCartOnAdd');
                'none' === Settings.getSettingValue('general.ajaxCartStyle') &&
                  (o = !1),
                  this.getCart(o);
              },
            },
            {
              key: 'onError',
              value: function (t, e, n) {
                var i = this,
                  r =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : p.action_list.atcAvailableLabel;
                this.changeButtonLabel(
                  e,
                  p.action_list.atcAddingToCartBtnLabel,
                  r
                );
                var o = '';
                '422' == t.status
                  ? (o = t.responseJSON
                      ? t.responseJSON.description
                      : t.description)
                  : console.log('ajaxAddToCartError: ' + t.status),
                  n && n.length > 0
                    ? (this.changeButtonLabel(n, null, o),
                      setTimeout(function () {
                        i.changeButtonLabel(n, null, '');
                      }, 2e3))
                    : o && alert(o);
              },
            },
            {
              key: 'changeButtonLabel',
              value: function (t, e, n) {
                if (t)
                  if (e) {
                    var i = t.html().toLowerCase().replace(e.toLowerCase(), n);
                    t.html(i);
                  } else t.html(n);
              },
            },
            {
              key: 'openAjaxCart',
              value: function (t) {
                var e = this;
                t && t.preventDefault(),
                  f('.boost-pfs-quickview-close').length > 0 &&
                    f('.boost-pfs-quickview-close').click(),
                  this.$element.addClass('boost-pfs-minicart-active'),
                  this.$element.addClass('boost-pfs-minicart-show'),
                  Settings.getSettingValue('general.autoCloseMiniCart') &&
                    setTimeout(function () {
                      e.$element.removeClass('boost-pfs-minicart-show'),
                        f('html').removeClass(
                          'boost-pfs-body-no-scroll-mini-cart'
                        );
                    }, Settings.getSettingValue(
                      'general.autoCloseMiniCartDuration'
                    )),
                  f('html').addClass('boost-pfs-body-no-scroll-mini-cart'),
                  this.hideSelectOption(),
                  document.activeElement &&
                    (this.$lastFocusedElement = f(document.activeElement)),
                  f('.boost-pfs-minicart-close').focus();
              },
            },
            {
              key: 'closeAjaxCart',
              value: function (t) {
                var e = f(t.target);
                (e.hasClass('boost-pfs-minicart-backdrop') ||
                  e.hasClass('boost-pfs-minicart-close')) &&
                  (document.activeElement &&
                    f(document.activeElement).hasClass(
                      'boost-pfs-minicart-close'
                    ) &&
                    this.$lastFocusedElement &&
                    this.$lastFocusedElement.focus(),
                  this.$element
                    .find('.boost-pfs-minicart-wrapper')
                    .removeClass('boost-pfs-minicart-active'),
                  this.$element.removeClass('boost-pfs-minicart-show'),
                  f('html').removeClass('boost-pfs-body-no-scroll-mini-cart'));
              },
            },
            {
              key: 'hideSelectOption',
              value: function () {
                f('body').removeClass('boost-pfs-select-option-show-body'),
                  f('.boost-pfs-select-option-show').removeClass(
                    'boost-pfs-select-option-show'
                  ),
                  f('.boost-pfs-select-option-wrapper').hide();
              },
            },
            {
              key: 'trapFocus',
              value: function (t) {
                if (
                  t &&
                  'Tab' == t.key &&
                  t.currentTarget &&
                  document.activeElement &&
                  this.$element &&
                  this.$element.hasClass('boost-pfs-minicart-show')
                ) {
                  var e = f(t.currentTarget);
                  t.shiftKey && e.hasClass('boost-pfs-minicart-close')
                    ? (t.preventDefault(), f('.boost-pfs-viewcart > a').focus())
                    : !t.shiftKey &&
                      e.hasClass('boost-pfs-viewcart') &&
                      (t.preventDefault(),
                      f('.boost-pfs-minicart-close').focus());
                }
              },
            },
            {
              key: 'setData',
              value: function (t) {
                var e = this;
                (this.isFetchedCartData = !0),
                  (t.original_total_price /= 100),
                  (t.total_price /= 100),
                  (t.total_discount /= 100),
                  (t.items_subtotal_price /= 100),
                  (this.children = []),
                  (this.cartItems = []),
                  t.items.forEach(function (t) {
                    (t.price /= 100),
                      (t.original_price /= 100),
                      (t.discounted_price /= 100),
                      (t.line_price /= 100),
                      (t.original_line_price /= 100),
                      (t.final_price /= 100),
                      (t.final_line_price /= 100),
                      (t.line_level_total_discount /= 100);
                    var n = new r.default();
                    n.setData(t), e.addComponent(n), e.cartItems.push(n);
                  }),
                  (this.data = t),
                  this.refresh();
              },
            },
            {
              key: 'updateTopCartCount',
              value: function (t) {
                var e = f(h.otpTopCartCount).html() || '0';
                f(h.otpTopCartCount).html(e.replace(/[0-9]+/, t)),
                  t > 0
                    ? f(h.otpTopCartCount)
                        .removeClass('hide')
                        .removeClass('critical-hidden')
                    : f(h.otpTopCartCount).addClass('hide');
              },
            },
            {
              key: 'updateCart',
              value: function (t, e, n) {
                var i = this;
                if (((e = parseInt(e)), !isNaN(e) && null != t)) {
                  var r = { id: t.toString(), quantity: parseInt(e) };
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(r),
                  })
                    .then(function (t) {
                      return t.json();
                    })
                    .then(function (t) {
                      if (null == t.status || 200 == t.status) {
                        var e = '',
                          r = t.total_price / 100;
                        f('.boost-pfs-subtotal-price').html(d.formatMoney(r));
                        for (
                          var o = n.attr('data-variant-id'), a = 0;
                          a < t.items.length;
                          a++
                        ) {
                          var s = (e = t.items[a]).line_price / 100;
                          f('.boost-pfs-minicart-item-' + e.variant_id)
                            .find('.boost-pfs-minicart-item-sub-total-price')
                            .html(d.formatMoney(s)),
                            o == e.variant_id && n.val(e.quantity);
                        }
                        var c = f('.boost-pfs-count-item').text();
                        f('.boost-pfs-count-item').html(
                          c.replace(/[0-9]+/, t.item_count)
                        ),
                          i.updateTopCartCount(t.item_count);
                      }
                    });
                }
              },
            },
            {
              key: 'clearCart',
              value: function () {
                f('.boost-pfs-minicart-clear-all').on('click', function (t) {
                  t.preventDefault(),
                    fetch('/cart/clear.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                    })
                      .then(function (t) {
                        return t.json();
                      })
                      .then(function (t) {
                        f('.boost-pfs-minicart-empty').show(),
                          f('.boost-pfs-minicart-bottom').hide(),
                          f('.boost-pfs-minicart-top').find('ol').html('');
                        var e = f('.boost-pfs-count-item').text();
                        f('.boost-pfs-count-item').html(
                          e.replace(/[0-9]+/, t.item_count)
                        );
                      });
                });
              },
            },
            {
              key: 'initActions',
              value: function () {
                var t = '[data-minus-qtt], [data-plus-qtt]';
                f(t),
                  f(document).on('click', t, function (t) {
                    t.preventDefault(), t.stopPropagation();
                    var e = f(this),
                      n = f(this)
                        .parents('.boost-pfs-minicart-item-quantity-wrapper')
                        .find('.boost-pfs-minicart-item-quantity'),
                      i = parseInt(d.stripHtml(n.val())),
                      r = 1,
                      o = '';
                    switch (!0) {
                      case e.hasClass('boost-pfs-minicart-item-quantity-plus'):
                        (r = i + 1),
                          (o = d.stripHtml(f(n).data('variant-id'))),
                          isNaN(o) || v.updateCart(o, r, n);
                        break;
                      case e.hasClass(
                        'boost-pfs-minicart-item-quantity-minus'
                      ) && i > 1:
                        (r = i - 1),
                          (o = d.stripHtml(f(n).data('variant-id'))),
                          isNaN(o) || v.updateCart(o, r, n);
                    }
                    n.val(r);
                  }),
                  f(document).on(
                    'input',
                    '.boost-pfs-minicart-item-quantity',
                    function (t) {
                      t.preventDefault(), t.stopPropagation();
                      var e = f(this)
                          .parents('.boost-pfs-minicart-item-quantity-wrapper')
                          .find('.boost-pfs-minicart-item-quantity'),
                        n = parseInt(d.stripHtml(t.target.value));
                      isNaN(n) && (n = 1);
                      var i = d.stripHtml(f(e).data('variant-id'));
                      isNaN(i) || v.updateCart(i, n, e);
                    }
                  );
              },
            },
          ]) && s(e.prototype, n),
          i && s(e, i),
          m
        );
      })(i.a);
    e.default = m;
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(42).find,
      o = n(64),
      a = n(22),
      s = !0,
      c = a('find');
    'find' in [] &&
      Array(1).find(function () {
        s = !1;
      }),
      i(
        { target: 'Array', proto: !0, forced: s || !c },
        {
          find: function (t) {
            return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
          },
        }
      ),
      o('find');
  },
  function (t, e, n) {
    var i = n(52),
      r = n(19);
    t.exports = function (t) {
      return i(r(t));
    };
  },
  function (t, e) {
    t.exports = function (t) {
      if (null == t) throw TypeError("Can't call method on " + t);
      return t;
    };
  },
  function (t, e, n) {
    var i = n(27),
      r = Math.min;
    t.exports = function (t) {
      return t > 0 ? r(i(t), 9007199254740991) : 0;
    };
  },
  function (t, e) {
    t.exports = function (t) {
      if ('function' != typeof t)
        throw TypeError(String(t) + ' is not a function');
      return t;
    };
  },
  function (t, e, n) {
    var i = n(8),
      r = n(1),
      o = n(6),
      a = Object.defineProperty,
      s = {},
      c = function (t) {
        throw t;
      };
    t.exports = function (t, e) {
      if (o(s, t)) return s[t];
      e || (e = {});
      var n = [][t],
        l = !!o(e, 'ACCESSORS') && e.ACCESSORS,
        u = o(e, 0) ? e[0] : c,
        f = o(e, 1) ? e[1] : void 0;
      return (s[t] =
        !!n &&
        !r(function () {
          if (l && !i) return !0;
          var t = { length: -1 };
          l ? a(t, 1, { enumerable: !0, get: c }) : (t[1] = 1), n.call(t, u, f);
        }));
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(18),
      r = n(64),
      o = n(35),
      a = n(25),
      s = n(100),
      c = a.set,
      l = a.getterFor('Array Iterator');
    (t.exports = s(
      Array,
      'Array',
      function (t, e) {
        c(this, { type: 'Array Iterator', target: i(t), index: 0, kind: e });
      },
      function () {
        var t = l(this),
          e = t.target,
          n = t.kind,
          i = t.index++;
        return !e || i >= e.length
          ? ((t.target = void 0), { value: void 0, done: !0 })
          : 'keys' == n
          ? { value: i, done: !1 }
          : 'values' == n
          ? { value: e[i], done: !1 }
          : { value: [i, e[i]], done: !1 };
      },
      'values'
    )),
      (o.Arguments = o.Array),
      r('keys'),
      r('values'),
      r('entries');
  },
  function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e,
      };
    };
  },
  function (t, e, n) {
    var i,
      r,
      o,
      a = n(110),
      s = n(0),
      c = n(5),
      l = n(10),
      u = n(6),
      f = n(40),
      p = n(41),
      d = s.WeakMap;
    if (a) {
      var h = new d(),
        v = h.get,
        m = h.has,
        b = h.set;
      (i = function (t, e) {
        return b.call(h, t, e), e;
      }),
        (r = function (t) {
          return v.call(h, t) || {};
        }),
        (o = function (t) {
          return m.call(h, t);
        });
    } else {
      var g = f('state');
      (p[g] = !0),
        (i = function (t, e) {
          return l(t, g, e), e;
        }),
        (r = function (t) {
          return u(t, g) ? t[g] : {};
        }),
        (o = function (t) {
          return u(t, g);
        });
    }
    t.exports = {
      set: i,
      get: r,
      has: o,
      enforce: function (t) {
        return o(t) ? r(t) : i(t, {});
      },
      getterFor: function (t) {
        return function (e) {
          var n;
          if (!c(e) || (n = r(e)).type !== t)
            throw TypeError('Incompatible receiver, ' + t + ' required');
          return n;
        };
      },
    };
  },
  function (t, e) {
    t.exports = !1;
  },
  function (t, e) {
    var n = Math.ceil,
      i = Math.floor;
    t.exports = function (t) {
      return isNaN((t = +t)) ? 0 : (t > 0 ? i : n)(t);
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(48);
    i({ target: 'RegExp', proto: !0, forced: /./.exec !== r }, { exec: r });
  },
  function (t, e, n) {
    n(3)({ target: 'Object', stat: !0 }, { setPrototypeOf: n(96) });
  },
  function (t, e, n) {
    var i = n(3),
      r = n(1),
      o = n(14),
      a = n(68),
      s = n(97);
    i(
      {
        target: 'Object',
        stat: !0,
        forced: r(function () {
          a(1);
        }),
        sham: !s,
      },
      {
        getPrototypeOf: function (t) {
          return a(o(t));
        },
      }
    );
  },
  function (t, e, n) {
    var i = n(3),
      r = n(13),
      o = n(21),
      a = n(4),
      s = n(5),
      c = n(43),
      l = n(122),
      u = n(1),
      f = r('Reflect', 'construct'),
      p = u(function () {
        function t() {}
        return !(f(function () {}, [], t) instanceof t);
      }),
      d = !u(function () {
        f(function () {});
      }),
      h = p || d;
    i(
      { target: 'Reflect', stat: !0, forced: h, sham: h },
      {
        construct: function (t, e) {
          o(t), a(e);
          var n = arguments.length < 3 ? t : o(arguments[2]);
          if (d && !p) return f(t, e, n);
          if (t == n) {
            switch (e.length) {
              case 0:
                return new t();
              case 1:
                return new t(e[0]);
              case 2:
                return new t(e[0], e[1]);
              case 3:
                return new t(e[0], e[1], e[2]);
              case 4:
                return new t(e[0], e[1], e[2], e[3]);
            }
            var i = [null];
            return i.push.apply(i, e), new (l.apply(t, i))();
          }
          var r = n.prototype,
            u = c(s(r) ? r : Object.prototype),
            h = Function.apply.call(t, u, e);
          return s(h) ? h : u;
        },
      }
    );
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(0),
      o = n(13),
      a = n(26),
      s = n(8),
      c = n(63),
      l = n(80),
      u = n(1),
      f = n(6),
      p = n(79),
      d = n(5),
      h = n(4),
      v = n(14),
      m = n(18),
      b = n(39),
      g = n(24),
      y = n(43),
      S = n(65),
      w = n(58),
      C = n(123),
      k = n(61),
      x = n(38),
      O = n(9),
      T = n(51),
      _ = n(10),
      j = n(12),
      E = n(56),
      P = n(40),
      $ = n(41),
      A = n(57),
      L = n(2),
      q = n(98),
      I = n(99),
      R = n(50),
      V = n(25),
      F = n(42).forEach,
      M = P('hidden'),
      D = L('toPrimitive'),
      B = V.set,
      Q = V.getterFor('Symbol'),
      N = Object.prototype,
      U = r.Symbol,
      G = o('JSON', 'stringify'),
      W = x.f,
      H = O.f,
      X = C.f,
      z = T.f,
      K = E('symbols'),
      J = E('op-symbols'),
      Y = E('string-to-symbol-registry'),
      Z = E('symbol-to-string-registry'),
      tt = E('wks'),
      et = r.QObject,
      nt = !et || !et.prototype || !et.prototype.findChild,
      it =
        s &&
        u(function () {
          return (
            7 !=
            y(
              H({}, 'a', {
                get: function () {
                  return H(this, 'a', { value: 7 }).a;
                },
              })
            ).a
          );
        })
          ? function (t, e, n) {
              var i = W(N, e);
              i && delete N[e], H(t, e, n), i && t !== N && H(N, e, i);
            }
          : H,
      rt = function (t, e) {
        var n = (K[t] = y(U.prototype));
        return (
          B(n, { type: 'Symbol', tag: t, description: e }),
          s || (n.description = e),
          n
        );
      },
      ot = l
        ? function (t) {
            return 'symbol' == typeof t;
          }
        : function (t) {
            return Object(t) instanceof U;
          },
      at = function (t, e, n) {
        t === N && at(J, e, n), h(t);
        var i = b(e, !0);
        return (
          h(n),
          f(K, i)
            ? (n.enumerable
                ? (f(t, M) && t[M][i] && (t[M][i] = !1),
                  (n = y(n, { enumerable: g(0, !1) })))
                : (f(t, M) || H(t, M, g(1, {})), (t[M][i] = !0)),
              it(t, i, n))
            : H(t, i, n)
        );
      },
      st = function (t, e) {
        h(t);
        var n = m(e),
          i = S(n).concat(ft(n));
        return (
          F(i, function (e) {
            (s && !ct.call(n, e)) || at(t, e, n[e]);
          }),
          t
        );
      },
      ct = function (t) {
        var e = b(t, !0),
          n = z.call(this, e);
        return (
          !(this === N && f(K, e) && !f(J, e)) &&
          (!(n || !f(this, e) || !f(K, e) || (f(this, M) && this[M][e])) || n)
        );
      },
      lt = function (t, e) {
        var n = m(t),
          i = b(e, !0);
        if (n !== N || !f(K, i) || f(J, i)) {
          var r = W(n, i);
          return (
            !r || !f(K, i) || (f(n, M) && n[M][i]) || (r.enumerable = !0), r
          );
        }
      },
      ut = function (t) {
        var e = X(m(t)),
          n = [];
        return (
          F(e, function (t) {
            f(K, t) || f($, t) || n.push(t);
          }),
          n
        );
      },
      ft = function (t) {
        var e = t === N,
          n = X(e ? J : m(t)),
          i = [];
        return (
          F(n, function (t) {
            !f(K, t) || (e && !f(N, t)) || i.push(K[t]);
          }),
          i
        );
      };
    (c ||
      (j(
        (U = function () {
          if (this instanceof U) throw TypeError('Symbol is not a constructor');
          var t =
              arguments.length && void 0 !== arguments[0]
                ? String(arguments[0])
                : void 0,
            e = A(t),
            n = function (t) {
              this === N && n.call(J, t),
                f(this, M) && f(this[M], e) && (this[M][e] = !1),
                it(this, e, g(1, t));
            };
          return s && nt && it(N, e, { configurable: !0, set: n }), rt(e, t);
        }).prototype,
        'toString',
        function () {
          return Q(this).tag;
        }
      ),
      j(U, 'withoutSetter', function (t) {
        return rt(A(t), t);
      }),
      (T.f = ct),
      (O.f = at),
      (x.f = lt),
      (w.f = C.f = ut),
      (k.f = ft),
      (q.f = function (t) {
        return rt(L(t), t);
      }),
      s &&
        (H(U.prototype, 'description', {
          configurable: !0,
          get: function () {
            return Q(this).description;
          },
        }),
        a || j(N, 'propertyIsEnumerable', ct, { unsafe: !0 }))),
    i({ global: !0, wrap: !0, forced: !c, sham: !c }, { Symbol: U }),
    F(S(tt), function (t) {
      I(t);
    }),
    i(
      { target: 'Symbol', stat: !0, forced: !c },
      {
        for: function (t) {
          var e = String(t);
          if (f(Y, e)) return Y[e];
          var n = U(e);
          return (Y[e] = n), (Z[n] = e), n;
        },
        keyFor: function (t) {
          if (!ot(t)) throw TypeError(t + ' is not a symbol');
          if (f(Z, t)) return Z[t];
        },
        useSetter: function () {
          nt = !0;
        },
        useSimple: function () {
          nt = !1;
        },
      }
    ),
    i(
      { target: 'Object', stat: !0, forced: !c, sham: !s },
      {
        create: function (t, e) {
          return void 0 === e ? y(t) : st(y(t), e);
        },
        defineProperty: at,
        defineProperties: st,
        getOwnPropertyDescriptor: lt,
      }
    ),
    i(
      { target: 'Object', stat: !0, forced: !c },
      { getOwnPropertyNames: ut, getOwnPropertySymbols: ft }
    ),
    i(
      {
        target: 'Object',
        stat: !0,
        forced: u(function () {
          k.f(1);
        }),
      },
      {
        getOwnPropertySymbols: function (t) {
          return k.f(v(t));
        },
      }
    ),
    G) &&
      i(
        {
          target: 'JSON',
          stat: !0,
          forced:
            !c ||
            u(function () {
              var t = U();
              return (
                '[null]' != G([t]) ||
                '{}' != G({ a: t }) ||
                '{}' != G(Object(t))
              );
            }),
        },
        {
          stringify: function (t, e, n) {
            for (var i, r = [t], o = 1; arguments.length > o; )
              r.push(arguments[o++]);
            if (((i = e), (d(e) || void 0 !== t) && !ot(t)))
              return (
                p(e) ||
                  (e = function (t, e) {
                    if (
                      ('function' == typeof i && (e = i.call(this, t, e)),
                      !ot(e))
                    )
                      return e;
                  }),
                (r[1] = e),
                G.apply(null, r)
              );
          },
        }
      );
    U.prototype[D] || _(U.prototype, D, U.prototype.valueOf),
      R(U, 'Symbol'),
      ($[M] = !0);
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(8),
      o = n(0),
      a = n(6),
      s = n(5),
      c = n(9).f,
      l = n(73),
      u = o.Symbol;
    if (
      r &&
      'function' == typeof u &&
      (!('description' in u.prototype) || void 0 !== u().description)
    ) {
      var f = {},
        p = function () {
          var t =
              arguments.length < 1 || void 0 === arguments[0]
                ? void 0
                : String(arguments[0]),
            e = this instanceof p ? new u(t) : void 0 === t ? u() : u(t);
          return '' === t && (f[e] = !0), e;
        };
      l(p, u);
      var d = (p.prototype = u.prototype);
      d.constructor = p;
      var h = d.toString,
        v = 'Symbol(test)' == String(u('test')),
        m = /^Symbol\((.*)\)[^)]+$/;
      c(d, 'description', {
        configurable: !0,
        get: function () {
          var t = s(this) ? this.valueOf() : this,
            e = h.call(t);
          if (a(f, t)) return '';
          var n = v ? e.slice(7, -1) : e.replace(m, '$1');
          return '' === n ? void 0 : n;
        },
      }),
        i({ global: !0, forced: !0 }, { Symbol: p });
    }
  },
  function (t, e, n) {
    n(99)('iterator');
  },
  function (t, e) {
    t.exports = {};
  },
  function (t, e, n) {
    'use strict';
    var i = n(94).charAt,
      r = n(25),
      o = n(100),
      a = r.set,
      s = r.getterFor('String Iterator');
    o(
      String,
      'String',
      function (t) {
        a(this, { type: 'String Iterator', string: String(t), index: 0 });
      },
      function () {
        var t,
          e = s(this),
          n = e.string,
          r = e.index;
        return r >= n.length
          ? { value: void 0, done: !0 }
          : ((t = i(n, r)), (e.index += t.length), { value: t, done: !1 });
      }
    );
  },
  function (t, e, n) {
    var i = n(0),
      r = n(90),
      o = n(23),
      a = n(10),
      s = n(2),
      c = s('iterator'),
      l = s('toStringTag'),
      u = o.values;
    for (var f in r) {
      var p = i[f],
        d = p && p.prototype;
      if (d) {
        if (d[c] !== u)
          try {
            a(d, c, u);
          } catch (t) {
            d[c] = u;
          }
        if ((d[l] || a(d, l, f), r[f]))
          for (var h in o)
            if (d[h] !== o[h])
              try {
                a(d, h, o[h]);
              } catch (t) {
                d[h] = o[h];
              }
      }
    }
  },
  function (t, e, n) {
    var i = n(8),
      r = n(51),
      o = n(24),
      a = n(18),
      s = n(39),
      c = n(6),
      l = n(71),
      u = Object.getOwnPropertyDescriptor;
    e.f = i
      ? u
      : function (t, e) {
          if (((t = a(t)), (e = s(e, !0)), l))
            try {
              return u(t, e);
            } catch (t) {}
          if (c(t, e)) return o(!r.f.call(t, e), t[e]);
        };
  },
  function (t, e, n) {
    var i = n(5);
    t.exports = function (t, e) {
      if (!i(t)) return t;
      var n, r;
      if (e && 'function' == typeof (n = t.toString) && !i((r = n.call(t))))
        return r;
      if ('function' == typeof (n = t.valueOf) && !i((r = n.call(t)))) return r;
      if (!e && 'function' == typeof (n = t.toString) && !i((r = n.call(t))))
        return r;
      throw TypeError("Can't convert object to primitive value");
    };
  },
  function (t, e, n) {
    var i = n(56),
      r = n(57),
      o = i('keys');
    t.exports = function (t) {
      return o[t] || (o[t] = r(t));
    };
  },
  function (t, e) {
    t.exports = {};
  },
  function (t, e, n) {
    var i = n(62),
      r = n(52),
      o = n(14),
      a = n(20),
      s = n(78),
      c = [].push,
      l = function (t) {
        var e = 1 == t,
          n = 2 == t,
          l = 3 == t,
          u = 4 == t,
          f = 6 == t,
          p = 5 == t || f;
        return function (d, h, v, m) {
          for (
            var b,
              g,
              y = o(d),
              S = r(y),
              w = i(h, v, 3),
              C = a(S.length),
              k = 0,
              x = m || s,
              O = e ? x(d, C) : n ? x(d, 0) : void 0;
            C > k;
            k++
          )
            if ((p || k in S) && ((g = w((b = S[k]), k, y)), t))
              if (e) O[k] = g;
              else if (g)
                switch (t) {
                  case 3:
                    return !0;
                  case 5:
                    return b;
                  case 6:
                    return k;
                  case 2:
                    c.call(O, b);
                }
              else if (u) return !1;
          return f ? -1 : l || u ? u : O;
        };
      };
    t.exports = {
      forEach: l(0),
      map: l(1),
      filter: l(2),
      some: l(3),
      every: l(4),
      find: l(5),
      findIndex: l(6),
    };
  },
  function (t, e, n) {
    var i,
      r = n(4),
      o = n(112),
      a = n(60),
      s = n(41),
      c = n(81),
      l = n(53),
      u = n(40),
      f = u('IE_PROTO'),
      p = function () {},
      d = function (t) {
        return '<script>' + t + '</script>';
      },
      h = function () {
        try {
          i = document.domain && new ActiveXObject('htmlfile');
        } catch (t) {}
        var t, e;
        h = i
          ? (function (t) {
              t.write(d('')), t.close();
              var e = t.parentWindow.Object;
              return (t = null), e;
            })(i)
          : (((e = l('iframe')).style.display = 'none'),
            c.appendChild(e),
            (e.src = String('javascript:')),
            (t = e.contentWindow.document).open(),
            t.write(d('document.F=Object')),
            t.close(),
            t.F);
        for (var n = a.length; n--; ) delete h.prototype[a[n]];
        return h();
      };
    (s[f] = !0),
      (t.exports =
        Object.create ||
        function (t, e) {
          var n;
          return (
            null !== t
              ? ((p.prototype = r(t)),
                (n = new p()),
                (p.prototype = null),
                (n[f] = t))
              : (n = h()),
            void 0 === e ? n : o(n, e)
          );
        });
  },
  function (t, e) {
    t.exports = '\t\n\v\f\r                　\u2028\u2029\ufeff';
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(89);
    i({ target: 'Array', proto: !0, forced: [].forEach != r }, { forEach: r });
  },
  function (t, e, n) {
    var i = n(0),
      r = n(90),
      o = n(89),
      a = n(10);
    for (var s in r) {
      var c = i[s],
        l = c && c.prototype;
      if (l && l.forEach !== o)
        try {
          a(l, 'forEach', o);
        } catch (t) {
          l.forEach = o;
        }
    }
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(67).trim;
    i(
      { target: 'String', proto: !0, forced: n(119)('trim') },
      {
        trim: function () {
          return r(this);
        },
      }
    );
  },
  function (t, e, n) {
    'use strict';
    var i,
      r,
      o = n(91),
      a = n(120),
      s = RegExp.prototype.exec,
      c = String.prototype.replace,
      l = s,
      u =
        ((i = /a/),
        (r = /b*/g),
        s.call(i, 'a'),
        s.call(r, 'a'),
        0 !== i.lastIndex || 0 !== r.lastIndex),
      f = a.UNSUPPORTED_Y || a.BROKEN_CARET,
      p = void 0 !== /()??/.exec('')[1];
    (u || p || f) &&
      (l = function (t) {
        var e,
          n,
          i,
          r,
          a = this,
          l = f && a.sticky,
          d = o.call(a),
          h = a.source,
          v = 0,
          m = t;
        return (
          l &&
            (-1 === (d = d.replace('y', '')).indexOf('g') && (d += 'g'),
            (m = String(t).slice(a.lastIndex)),
            a.lastIndex > 0 &&
              (!a.multiline || (a.multiline && '\n' !== t[a.lastIndex - 1])) &&
              ((h = '(?: ' + h + ')'), (m = ' ' + m), v++),
            (n = new RegExp('^(?:' + h + ')', d))),
          p && (n = new RegExp('^' + h + '$(?!\\s)', d)),
          u && (e = a.lastIndex),
          (i = s.call(l ? n : a, m)),
          l
            ? i
              ? ((i.input = i.input.slice(v)),
                (i[0] = i[0].slice(v)),
                (i.index = a.lastIndex),
                (a.lastIndex += i[0].length))
              : (a.lastIndex = 0)
            : u && i && (a.lastIndex = a.global ? i.index + i[0].length : e),
          p &&
            i &&
            i.length > 1 &&
            c.call(i[0], n, function () {
              for (r = 1; r < arguments.length - 2; r++)
                void 0 === arguments[r] && (i[r] = void 0);
            }),
          i
        );
      }),
      (t.exports = l);
  },
  function (t, e, n) {
    'use strict';
    var i = n(92),
      r = n(4),
      o = n(14),
      a = n(20),
      s = n(27),
      c = n(19),
      l = n(93),
      u = n(95),
      f = Math.max,
      p = Math.min,
      d = Math.floor,
      h = /\$([$&'`]|\d\d?|<[^>]*>)/g,
      v = /\$([$&'`]|\d\d?)/g;
    i('replace', 2, function (t, e, n, i) {
      var m = i.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
        b = i.REPLACE_KEEPS_$0,
        g = m ? '$' : '$0';
      return [
        function (n, i) {
          var r = c(this),
            o = null == n ? void 0 : n[t];
          return void 0 !== o ? o.call(n, r, i) : e.call(String(r), n, i);
        },
        function (t, i) {
          if ((!m && b) || ('string' == typeof i && -1 === i.indexOf(g))) {
            var o = n(e, t, this, i);
            if (o.done) return o.value;
          }
          var c = r(t),
            d = String(this),
            h = 'function' == typeof i;
          h || (i = String(i));
          var v = c.global;
          if (v) {
            var S = c.unicode;
            c.lastIndex = 0;
          }
          for (var w = []; ; ) {
            var C = u(c, d);
            if (null === C) break;
            if ((w.push(C), !v)) break;
            '' === String(C[0]) && (c.lastIndex = l(d, a(c.lastIndex), S));
          }
          for (var k, x = '', O = 0, T = 0; T < w.length; T++) {
            C = w[T];
            for (
              var _ = String(C[0]),
                j = f(p(s(C.index), d.length), 0),
                E = [],
                P = 1;
              P < C.length;
              P++
            )
              E.push(void 0 === (k = C[P]) ? k : String(k));
            var $ = C.groups;
            if (h) {
              var A = [_].concat(E, j, d);
              void 0 !== $ && A.push($);
              var L = String(i.apply(void 0, A));
            } else L = y(_, d, j, E, $, i);
            j >= O && ((x += d.slice(O, j) + L), (O = j + _.length));
          }
          return x + d.slice(O);
        },
      ];
      function y(t, n, i, r, a, s) {
        var c = i + t.length,
          l = r.length,
          u = v;
        return (
          void 0 !== a && ((a = o(a)), (u = h)),
          e.call(s, u, function (e, o) {
            var s;
            switch (o.charAt(0)) {
              case '$':
                return '$';
              case '&':
                return t;
              case '`':
                return n.slice(0, i);
              case "'":
                return n.slice(c);
              case '<':
                s = a[o.slice(1, -1)];
                break;
              default:
                var u = +o;
                if (0 === u) return e;
                if (u > l) {
                  var f = d(u / 10);
                  return 0 === f
                    ? e
                    : f <= l
                    ? void 0 === r[f - 1]
                      ? o.charAt(1)
                      : r[f - 1] + o.charAt(1)
                    : e;
                }
                s = r[u - 1];
            }
            return void 0 === s ? '' : s;
          })
        );
      }
    });
  },
  function (t, e, n) {
    var i = n(9).f,
      r = n(6),
      o = n(2)('toStringTag');
    t.exports = function (t, e, n) {
      t &&
        !r((t = n ? t : t.prototype), o) &&
        i(t, o, { configurable: !0, value: e });
    };
  },
  function (t, e, n) {
    'use strict';
    var i = {}.propertyIsEnumerable,
      r = Object.getOwnPropertyDescriptor,
      o = r && !i.call({ 1: 2 }, 1);
    e.f = o
      ? function (t) {
          var e = r(this, t);
          return !!e && e.enumerable;
        }
      : i;
  },
  function (t, e, n) {
    var i = n(1),
      r = n(11),
      o = ''.split;
    t.exports = i(function () {
      return !Object('z').propertyIsEnumerable(0);
    })
      ? function (t) {
          return 'String' == r(t) ? o.call(t, '') : Object(t);
        }
      : Object;
  },
  function (t, e, n) {
    var i = n(0),
      r = n(5),
      o = i.document,
      a = r(o) && r(o.createElement);
    t.exports = function (t) {
      return a ? o.createElement(t) : {};
    };
  },
  function (t, e, n) {
    var i = n(0),
      r = n(10);
    t.exports = function (t, e) {
      try {
        r(i, t, e);
      } catch (n) {
        i[t] = e;
      }
      return e;
    };
  },
  function (t, e, n) {
    var i = n(72),
      r = Function.toString;
    'function' != typeof i.inspectSource &&
      (i.inspectSource = function (t) {
        return r.call(t);
      }),
      (t.exports = i.inspectSource);
  },
  function (t, e, n) {
    var i = n(26),
      r = n(72);
    (t.exports = function (t, e) {
      return r[t] || (r[t] = void 0 !== e ? e : {});
    })('versions', []).push({
      version: '3.6.4',
      mode: i ? 'pure' : 'global',
      copyright: '© 2020 Denis Pushkarev (zloirock.ru)',
    });
  },
  function (t, e) {
    var n = 0,
      i = Math.random();
    t.exports = function (t) {
      return (
        'Symbol(' +
        String(void 0 === t ? '' : t) +
        ')_' +
        (++n + i).toString(36)
      );
    };
  },
  function (t, e, n) {
    var i = n(75),
      r = n(60).concat('length', 'prototype');
    e.f =
      Object.getOwnPropertyNames ||
      function (t) {
        return i(t, r);
      };
  },
  function (t, e, n) {
    var i = n(18),
      r = n(20),
      o = n(76),
      a = function (t) {
        return function (e, n, a) {
          var s,
            c = i(e),
            l = r(c.length),
            u = o(a, l);
          if (t && n != n) {
            for (; l > u; ) if ((s = c[u++]) != s) return !0;
          } else
            for (; l > u; u++)
              if ((t || u in c) && c[u] === n) return t || u || 0;
          return !t && -1;
        };
      };
    t.exports = { includes: a(!0), indexOf: a(!1) };
  },
  function (t, e) {
    t.exports = [
      'constructor',
      'hasOwnProperty',
      'isPrototypeOf',
      'propertyIsEnumerable',
      'toLocaleString',
      'toString',
      'valueOf',
    ];
  },
  function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  },
  function (t, e, n) {
    var i = n(21);
    t.exports = function (t, e, n) {
      if ((i(t), void 0 === e)) return t;
      switch (n) {
        case 0:
          return function () {
            return t.call(e);
          };
        case 1:
          return function (n) {
            return t.call(e, n);
          };
        case 2:
          return function (n, i) {
            return t.call(e, n, i);
          };
        case 3:
          return function (n, i, r) {
            return t.call(e, n, i, r);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    };
  },
  function (t, e, n) {
    var i = n(1);
    t.exports =
      !!Object.getOwnPropertySymbols &&
      !i(function () {
        return !String(Symbol());
      });
  },
  function (t, e, n) {
    var i = n(2),
      r = n(43),
      o = n(9),
      a = i('unscopables'),
      s = Array.prototype;
    null == s[a] && o.f(s, a, { configurable: !0, value: r(null) }),
      (t.exports = function (t) {
        s[a][t] = !0;
      });
  },
  function (t, e, n) {
    var i = n(75),
      r = n(60);
    t.exports =
      Object.keys ||
      function (t) {
        return i(t, r);
      };
  },
  function (t, e, n) {
    var i = {};
    (i[n(2)('toStringTag')] = 'z'), (t.exports = '[object z]' === String(i));
  },
  function (t, e, n) {
    var i = n(19),
      r = '[' + n(44) + ']',
      o = RegExp('^' + r + r + '*'),
      a = RegExp(r + r + '*$'),
      s = function (t) {
        return function (e) {
          var n = String(i(e));
          return (
            1 & t && (n = n.replace(o, '')), 2 & t && (n = n.replace(a, '')), n
          );
        };
      };
    t.exports = { start: s(1), end: s(2), trim: s(3) };
  },
  function (t, e, n) {
    var i = n(6),
      r = n(14),
      o = n(40),
      a = n(97),
      s = o('IE_PROTO'),
      c = Object.prototype;
    t.exports = a
      ? Object.getPrototypeOf
      : function (t) {
          return (
            (t = r(t)),
            i(t, s)
              ? t[s]
              : 'function' == typeof t.constructor && t instanceof t.constructor
              ? t.constructor.prototype
              : t instanceof Object
              ? c
              : null
          );
        };
  },
  function (t, e, n) {
    var i = n(8),
      r = n(9).f,
      o = Function.prototype,
      a = o.toString,
      s = /^\s*function ([^ (]*)/;
    i &&
      !('name' in o) &&
      r(o, 'name', {
        configurable: !0,
        get: function () {
          try {
            return a.call(this).match(s)[1];
          } catch (t) {
            return '';
          }
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e);
    n(47),
      n(28),
      n(49),
      n(17),
      n(15),
      n(69),
      n(29),
      n(30),
      n(31),
      n(32),
      n(33),
      n(34),
      n(23),
      n(36),
      n(37);
    var i = n(7);
    function r(t) {
      return (r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            })(t);
    }
    function o(t, e) {
      if (!(t instanceof e))
        throw new TypeError('Cannot call a class as a function');
    }
    function a(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function s(t, e) {
      return (s =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function c(t, e) {
      return !e || ('object' !== r(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t)
        : e;
    }
    function l(t) {
      return (l = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var u = BoostPFS.jQ,
      f = BoostPFS.Utils,
      p = (function (t) {
        !(function (t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError(
              'Super expression must either be null or a function'
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && s(t, e);
        })(p, t);
        var e,
          n,
          i,
          r = (function (t) {
            function e() {
              if ('undefined' == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ('function' == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = l(t);
              if (e()) {
                var r = l(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return c(this, n);
            };
          })(p);
        function p() {
          return o(this, p), r.apply(this, arguments);
        }
        return (
          (e = p),
          (n = [
            {
              key: 'getTemplate',
              value: function () {
                return '\n\t\t<li class="boost-pfs-minicart-item boost-pfs-minicart-item-{{variantId}}">\n\t\t\t<a href="{{variantUrl}}" title="{{productTitle}}" class="boost-pfs-minicart-item-image">\n\t\t\t\t<img src="{{variantImage}}" alt="{{productTitle}}">\n\t\t\t</a>\n\t\t\t<div class="boost-pfs-minicart-item-details">\n\t\t\t\t<div class="boost-pfs-minicart-item-details-inner">\n\t\t\t\t\t<div class="boost-pfs-minicart-item-group-title">\n\t\t\t\t\t\t<p class="boost-pfs-minicart-item-name">\n\t\t\t\t\t\t\t<a href="{{variantUrl}}">{{productTitle}}</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p class="boost-pfs-minicart-item-vendor">{{vendor}}</p>\n\t\t\t\t\t\t<div class="boost-pfs-minicart-item-options">{{productOptions}}</div>\n\t\t\t\t\t\t<button title="Remove this item" class="boost-pfs-minicart-item-remove"><span class="boost-pfs-minicart-item-remove-icon"></span><span class="boost-pfs-minicart-item-remove-text">×</span></button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="boost-pfs-minicart-item-group-price">\n\t\t\t\t\t\t<div class="boost-pfs-minicart-item-price"><span class="money">{{price}}</span></div>\n\t\t\t\t\t\t<div class="boost-pfs-minicart-item-collateral">\n\t\t\t\t\t\t\t<div class="boost-pfs-minicart-item-quantity-wrapper">\n\t\t\t\t\t\t\t\t<button data-minus-qtt="" class="boost-pfs-minicart-item-quantity-minus">-</button>\n\t\t\t\t\t\t\t\t<input class="boost-pfs-minicart-item-quantity" type="number" name="updates[]" id=""\n\t\t\t\t\t\t\t\t\t   value="{{quantity}}" min="0" aria-label="Item quantity"\n\t\t\t\t\t\t\t\t\t   data-variant-id="{{variantId}}" role="textbox">\n\t\t\t\t\t\t\t\t<button data-plus-qtt="" class="boost-pfs-minicart-item-quantity-plus">+</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<span class="boost-pfs-minicart-item-line">x</span>\n\t\t\t\t\t\t\t<span class="boost-pfs-minicart-item-price"><span class="money">{{price}}</span></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="boost-pfs-minicart-item-sub-total-price"><span class="money">{{subTotalPrice}}</span></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</li>'.trim();
              },
            },
            {
              key: 'compileTemplate',
              value: function () {
                var t = this.data.image
                  ? this.data.image
                  : this.data.featured_image && this.data.featured_image.url
                  ? this.data.featured_image.url
                  : boostPFSConfig.general.no_image_url;
                return this.getTemplate()
                  .replace(/{{variantUrl}}/g, this.data.url)
                  .replace(/{{productTitle}}/g, this.data.product_title)
                  .replace(/{{productId}}/g, this.data.product_id)
                  .replace(/{{vendor}}/g, this.data.vendor)
                  .replace(/{{variantImage}}/g, t)
                  .replace(
                    /{{productOptions}}/g,
                    this.getProductOptions(this.data)
                  )
                  .replace(/{{variantId}}/g, this.data.variant_id)
                  .replace(/{{quantity}}/g, this.data.quantity)
                  .replace(/{{price}}/g, f.formatMoney(this.data.price))
                  .replace(
                    /{{subTotalPrice}}/g,
                    f.formatMoney(this.data.line_price)
                  );
              },
            },
            {
              key: 'isRender',
              value: function () {
                return this.parent.isFetchedCartData;
              },
            },
            {
              key: 'render',
              value: function () {
                this.$element || (this.$element = u(this.compileTemplate()));
              },
            },
            {
              key: 'isBindEvents',
              value: function () {
                return this.parent.isFetchedCartData;
              },
            },
            {
              key: 'bindEvents',
              value: function () {
                this.$element &&
                  this.$element
                    .find('.boost-pfs-minicart-item-remove')
                    .on('click', this.onClickRemoveItem.bind(this));
              },
            },
            {
              key: 'onClickRemoveItem',
              value: function (t) {
                t && t.preventDefault(),
                  this.parent.removeFromCart(this.data.variant_id);
              },
            },
            {
              key: 'setData',
              value: function (t) {
                this.data = t;
              },
            },
            {
              key: 'getProductOptions',
              value: function (t) {
                for (var e = '', n = 0; n < t.options_with_values.length; n++) {
                  var i = t.options_with_values[n];
                  'Title' != i.name &&
                    (e +=
                      '<div class="boost-pfs-minicart-item-option-element"><span class="boost-pfs-minicart-item-option-name">' +
                      i.name +
                      ':</span><span class="boost-pfs-minicart-item-option-value">' +
                      i.value +
                      '</span></div>');
                }
                return e;
              },
            },
          ]) && a(e.prototype, n),
          i && a(e, i),
          p
        );
      })(i.a);
    e.default = p;
  },
  function (t, e, n) {
    var i = n(8),
      r = n(1),
      o = n(53);
    t.exports =
      !i &&
      !r(function () {
        return (
          7 !=
          Object.defineProperty(o('div'), 'a', {
            get: function () {
              return 7;
            },
          }).a
        );
      });
  },
  function (t, e, n) {
    var i = n(0),
      r = n(54),
      o = i['__core-js_shared__'] || r('__core-js_shared__', {});
    t.exports = o;
  },
  function (t, e, n) {
    var i = n(6),
      r = n(111),
      o = n(38),
      a = n(9);
    t.exports = function (t, e) {
      for (var n = r(e), s = a.f, c = o.f, l = 0; l < n.length; l++) {
        var u = n[l];
        i(t, u) || s(t, u, c(e, u));
      }
    };
  },
  function (t, e, n) {
    var i = n(0);
    t.exports = i;
  },
  function (t, e, n) {
    var i = n(6),
      r = n(18),
      o = n(59).indexOf,
      a = n(41);
    t.exports = function (t, e) {
      var n,
        s = r(t),
        c = 0,
        l = [];
      for (n in s) !i(a, n) && i(s, n) && l.push(n);
      for (; e.length > c; ) i(s, (n = e[c++])) && (~o(l, n) || l.push(n));
      return l;
    };
  },
  function (t, e, n) {
    var i = n(27),
      r = Math.max,
      o = Math.min;
    t.exports = function (t, e) {
      var n = i(t);
      return n < 0 ? r(n + e, 0) : o(n, e);
    };
  },
  function (t, e, n) {
    var i = n(1),
      r = /#|\.prototype\./,
      o = function (t, e) {
        var n = s[a(t)];
        return n == l || (n != c && ('function' == typeof e ? i(e) : !!e));
      },
      a = (o.normalize = function (t) {
        return String(t).replace(r, '.').toLowerCase();
      }),
      s = (o.data = {}),
      c = (o.NATIVE = 'N'),
      l = (o.POLYFILL = 'P');
    t.exports = o;
  },
  function (t, e, n) {
    var i = n(5),
      r = n(79),
      o = n(2)('species');
    t.exports = function (t, e) {
      var n;
      return (
        r(t) &&
          ('function' != typeof (n = t.constructor) ||
          (n !== Array && !r(n.prototype))
            ? i(n) && null === (n = n[o]) && (n = void 0)
            : (n = void 0)),
        new (void 0 === n ? Array : n)(0 === e ? 0 : e)
      );
    };
  },
  function (t, e, n) {
    var i = n(11);
    t.exports =
      Array.isArray ||
      function (t) {
        return 'Array' == i(t);
      };
  },
  function (t, e, n) {
    var i = n(63);
    t.exports = i && !Symbol.sham && 'symbol' == typeof Symbol.iterator;
  },
  function (t, e, n) {
    var i = n(13);
    t.exports = i('document', 'documentElement');
  },
  function (t, e, n) {
    var i = n(66),
      r = n(11),
      o = n(2)('toStringTag'),
      a =
        'Arguments' ==
        r(
          (function () {
            return arguments;
          })()
        );
    t.exports = i
      ? r
      : function (t) {
          var e, n, i;
          return void 0 === t
            ? 'Undefined'
            : null === t
            ? 'Null'
            : 'string' ==
              typeof (n = (function (t, e) {
                try {
                  return t[e];
                } catch (t) {}
              })((e = Object(t)), o))
            ? n
            : a
            ? r(e)
            : 'Object' == (i = r(e)) && 'function' == typeof e.callee
            ? 'Arguments'
            : i;
        };
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(59).includes,
      o = n(64);
    i(
      {
        target: 'Array',
        proto: !0,
        forced: !n(22)('indexOf', { ACCESSORS: !0, 1: 0 }),
      },
      {
        includes: function (t) {
          return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    ),
      o('includes');
  },
  function (t, e, n) {
    var i = n(3),
      r = n(114);
    i({ global: !0, forced: parseInt != r }, { parseInt: r });
  },
  function (t, e, n) {
    'use strict';
    var i = n(1);
    t.exports = function (t, e) {
      var n = [][t];
      return (
        !!n &&
        i(function () {
          n.call(
            null,
            e ||
              function () {
                throw 1;
              },
            1
          );
        })
      );
    };
  },
  function (t, e, n) {
    var i = n(1),
      r = n(2),
      o = n(87),
      a = r('species');
    t.exports = function (t) {
      return (
        o >= 51 ||
        !i(function () {
          var e = [];
          return (
            ((e.constructor = {})[a] = function () {
              return { foo: 1 };
            }),
            1 !== e[t](Boolean).foo
          );
        })
      );
    };
  },
  function (t, e, n) {
    var i,
      r,
      o = n(0),
      a = n(88),
      s = o.process,
      c = s && s.versions,
      l = c && c.v8;
    l
      ? (r = (i = l.split('.'))[0] + i[1])
      : a &&
        (!(i = a.match(/Edge\/(\d+)/)) || i[1] >= 74) &&
        (i = a.match(/Chrome\/(\d+)/)) &&
        (r = i[1]),
      (t.exports = r && +r);
  },
  function (t, e, n) {
    var i = n(13);
    t.exports = i('navigator', 'userAgent') || '';
  },
  function (t, e, n) {
    'use strict';
    var i = n(42).forEach,
      r = n(85),
      o = n(22),
      a = r('forEach'),
      s = o('forEach');
    t.exports =
      a && s
        ? [].forEach
        : function (t) {
            return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
          };
  },
  function (t, e) {
    t.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0,
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(4);
    t.exports = function () {
      var t = i(this),
        e = '';
      return (
        t.global && (e += 'g'),
        t.ignoreCase && (e += 'i'),
        t.multiline && (e += 'm'),
        t.dotAll && (e += 's'),
        t.unicode && (e += 'u'),
        t.sticky && (e += 'y'),
        e
      );
    };
  },
  function (t, e, n) {
    'use strict';
    n(28);
    var i = n(12),
      r = n(1),
      o = n(2),
      a = n(48),
      s = n(10),
      c = o('species'),
      l = !r(function () {
        var t = /./;
        return (
          (t.exec = function () {
            var t = [];
            return (t.groups = { a: '7' }), t;
          }),
          '7' !== ''.replace(t, '$<a>')
        );
      }),
      u = '$0' === 'a'.replace(/./, '$0'),
      f = o('replace'),
      p = !!/./[f] && '' === /./[f]('a', '$0'),
      d = !r(function () {
        var t = /(?:)/,
          e = t.exec;
        t.exec = function () {
          return e.apply(this, arguments);
        };
        var n = 'ab'.split(t);
        return 2 !== n.length || 'a' !== n[0] || 'b' !== n[1];
      });
    t.exports = function (t, e, n, f) {
      var h = o(t),
        v = !r(function () {
          var e = {};
          return (
            (e[h] = function () {
              return 7;
            }),
            7 != ''[t](e)
          );
        }),
        m =
          v &&
          !r(function () {
            var e = !1,
              n = /a/;
            return (
              'split' === t &&
                (((n = {}).constructor = {}),
                (n.constructor[c] = function () {
                  return n;
                }),
                (n.flags = ''),
                (n[h] = /./[h])),
              (n.exec = function () {
                return (e = !0), null;
              }),
              n[h](''),
              !e
            );
          });
      if (
        !v ||
        !m ||
        ('replace' === t && (!l || !u || p)) ||
        ('split' === t && !d)
      ) {
        var b = /./[h],
          g = n(
            h,
            ''[t],
            function (t, e, n, i, r) {
              return e.exec === a
                ? v && !r
                  ? { done: !0, value: b.call(e, n, i) }
                  : { done: !0, value: t.call(n, e, i) }
                : { done: !1 };
            },
            {
              REPLACE_KEEPS_$0: u,
              REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: p,
            }
          ),
          y = g[0],
          S = g[1];
        i(String.prototype, t, y),
          i(
            RegExp.prototype,
            h,
            2 == e
              ? function (t, e) {
                  return S.call(t, this, e);
                }
              : function (t) {
                  return S.call(t, this);
                }
          );
      }
      f && s(RegExp.prototype[h], 'sham', !0);
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(94).charAt;
    t.exports = function (t, e, n) {
      return e + (n ? i(t, e).length : 1);
    };
  },
  function (t, e, n) {
    var i = n(27),
      r = n(19),
      o = function (t) {
        return function (e, n) {
          var o,
            a,
            s = String(r(e)),
            c = i(n),
            l = s.length;
          return c < 0 || c >= l
            ? t
              ? ''
              : void 0
            : (o = s.charCodeAt(c)) < 55296 ||
              o > 56319 ||
              c + 1 === l ||
              (a = s.charCodeAt(c + 1)) < 56320 ||
              a > 57343
            ? t
              ? s.charAt(c)
              : o
            : t
            ? s.slice(c, c + 2)
            : a - 56320 + ((o - 55296) << 10) + 65536;
        };
      };
    t.exports = { codeAt: o(!1), charAt: o(!0) };
  },
  function (t, e, n) {
    var i = n(11),
      r = n(48);
    t.exports = function (t, e) {
      var n = t.exec;
      if ('function' == typeof n) {
        var o = n.call(t, e);
        if ('object' != typeof o)
          throw TypeError(
            'RegExp exec method returned something other than an Object or null'
          );
        return o;
      }
      if ('RegExp' !== i(t))
        throw TypeError('RegExp#exec called on incompatible receiver');
      return r.call(t, e);
    };
  },
  function (t, e, n) {
    var i = n(4),
      r = n(121);
    t.exports =
      Object.setPrototypeOf ||
      ('__proto__' in {}
        ? (function () {
            var t,
              e = !1,
              n = {};
            try {
              (t = Object.getOwnPropertyDescriptor(
                Object.prototype,
                '__proto__'
              ).set).call(n, []),
                (e = n instanceof Array);
            } catch (t) {}
            return function (n, o) {
              return i(n), r(o), e ? t.call(n, o) : (n.__proto__ = o), n;
            };
          })()
        : void 0);
  },
  function (t, e, n) {
    var i = n(1);
    t.exports = !i(function () {
      function t() {}
      return (
        (t.prototype.constructor = null),
        Object.getPrototypeOf(new t()) !== t.prototype
      );
    });
  },
  function (t, e, n) {
    var i = n(2);
    e.f = i;
  },
  function (t, e, n) {
    var i = n(74),
      r = n(6),
      o = n(98),
      a = n(9).f;
    t.exports = function (t) {
      var e = i.Symbol || (i.Symbol = {});
      r(e, t) || a(e, t, { value: o.f(t) });
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(124),
      o = n(68),
      a = n(96),
      s = n(50),
      c = n(10),
      l = n(12),
      u = n(2),
      f = n(26),
      p = n(35),
      d = n(101),
      h = d.IteratorPrototype,
      v = d.BUGGY_SAFARI_ITERATORS,
      m = u('iterator'),
      b = function () {
        return this;
      };
    t.exports = function (t, e, n, u, d, g, y) {
      r(n, e, u);
      var S,
        w,
        C,
        k = function (t) {
          if (t === d && j) return j;
          if (!v && t in T) return T[t];
          switch (t) {
            case 'keys':
            case 'values':
            case 'entries':
              return function () {
                return new n(this, t);
              };
          }
          return function () {
            return new n(this);
          };
        },
        x = e + ' Iterator',
        O = !1,
        T = t.prototype,
        _ = T[m] || T['@@iterator'] || (d && T[d]),
        j = (!v && _) || k(d),
        E = ('Array' == e && T.entries) || _;
      if (
        (E &&
          ((S = o(E.call(new t()))),
          h !== Object.prototype &&
            S.next &&
            (f ||
              o(S) === h ||
              (a ? a(S, h) : 'function' != typeof S[m] && c(S, m, b)),
            s(S, x, !0, !0),
            f && (p[x] = b))),
        'values' == d &&
          _ &&
          'values' !== _.name &&
          ((O = !0),
          (j = function () {
            return _.call(this);
          })),
        (f && !y) || T[m] === j || c(T, m, j),
        (p[e] = j),
        d)
      )
        if (
          ((w = {
            values: k('values'),
            keys: g ? j : k('keys'),
            entries: k('entries'),
          }),
          y)
        )
          for (C in w) (v || O || !(C in T)) && l(T, C, w[C]);
        else i({ target: e, proto: !0, forced: v || O }, w);
      return w;
    };
  },
  function (t, e, n) {
    'use strict';
    var i,
      r,
      o,
      a = n(68),
      s = n(10),
      c = n(6),
      l = n(2),
      u = n(26),
      f = l('iterator'),
      p = !1;
    [].keys &&
      ('next' in (o = [].keys())
        ? (r = a(a(o))) !== Object.prototype && (i = r)
        : (p = !0)),
      null == i && (i = {}),
      u ||
        c(i, f) ||
        s(i, f, function () {
          return this;
        }),
      (t.exports = { IteratorPrototype: i, BUGGY_SAFARI_ITERATORS: p });
  },
  function (t, e, n) {
    'use strict';
    var i,
      r,
      o,
      a,
      s = n(3),
      c = n(26),
      l = n(0),
      u = n(13),
      f = n(125),
      p = n(12),
      d = n(126),
      h = n(50),
      v = n(127),
      m = n(5),
      b = n(21),
      g = n(128),
      y = n(11),
      S = n(55),
      w = n(129),
      C = n(133),
      k = n(103),
      x = n(104).set,
      O = n(134),
      T = n(135),
      _ = n(136),
      j = n(106),
      E = n(137),
      P = n(25),
      $ = n(77),
      A = n(2),
      L = n(87),
      q = A('species'),
      I = 'Promise',
      R = P.get,
      V = P.set,
      F = P.getterFor(I),
      M = f,
      D = l.TypeError,
      B = l.document,
      Q = l.process,
      N = u('fetch'),
      U = j.f,
      G = U,
      W = 'process' == y(Q),
      H = !!(B && B.createEvent && l.dispatchEvent),
      X = $(I, function () {
        if (!(S(M) !== String(M))) {
          if (66 === L) return !0;
          if (!W && 'function' != typeof PromiseRejectionEvent) return !0;
        }
        if (c && !M.prototype.finally) return !0;
        if (L >= 51 && /native code/.test(M)) return !1;
        var t = M.resolve(1),
          e = function (t) {
            t(
              function () {},
              function () {}
            );
          };
        return (
          ((t.constructor = {})[q] = e), !(t.then(function () {}) instanceof e)
        );
      }),
      z =
        X ||
        !C(function (t) {
          M.all(t).catch(function () {});
        }),
      K = function (t) {
        var e;
        return !(!m(t) || 'function' != typeof (e = t.then)) && e;
      },
      J = function (t, e, n) {
        if (!e.notified) {
          e.notified = !0;
          var i = e.reactions;
          O(function () {
            for (var r = e.value, o = 1 == e.state, a = 0; i.length > a; ) {
              var s,
                c,
                l,
                u = i[a++],
                f = o ? u.ok : u.fail,
                p = u.resolve,
                d = u.reject,
                h = u.domain;
              try {
                f
                  ? (o || (2 === e.rejection && et(t, e), (e.rejection = 1)),
                    !0 === f
                      ? (s = r)
                      : (h && h.enter(), (s = f(r)), h && (h.exit(), (l = !0))),
                    s === u.promise
                      ? d(D('Promise-chain cycle'))
                      : (c = K(s))
                      ? c.call(s, p, d)
                      : p(s))
                  : d(r);
              } catch (t) {
                h && !l && h.exit(), d(t);
              }
            }
            (e.reactions = []), (e.notified = !1), n && !e.rejection && Z(t, e);
          });
        }
      },
      Y = function (t, e, n) {
        var i, r;
        H
          ? (((i = B.createEvent('Event')).promise = e),
            (i.reason = n),
            i.initEvent(t, !1, !0),
            l.dispatchEvent(i))
          : (i = { promise: e, reason: n }),
          (r = l['on' + t])
            ? r(i)
            : 'unhandledrejection' === t && _('Unhandled promise rejection', n);
      },
      Z = function (t, e) {
        x.call(l, function () {
          var n,
            i = e.value;
          if (
            tt(e) &&
            ((n = E(function () {
              W
                ? Q.emit('unhandledRejection', i, t)
                : Y('unhandledrejection', t, i);
            })),
            (e.rejection = W || tt(e) ? 2 : 1),
            n.error)
          )
            throw n.value;
        });
      },
      tt = function (t) {
        return 1 !== t.rejection && !t.parent;
      },
      et = function (t, e) {
        x.call(l, function () {
          W ? Q.emit('rejectionHandled', t) : Y('rejectionhandled', t, e.value);
        });
      },
      nt = function (t, e, n, i) {
        return function (r) {
          t(e, n, r, i);
        };
      },
      it = function (t, e, n, i) {
        e.done ||
          ((e.done = !0),
          i && (e = i),
          (e.value = n),
          (e.state = 2),
          J(t, e, !0));
      },
      rt = function (t, e, n, i) {
        if (!e.done) {
          (e.done = !0), i && (e = i);
          try {
            if (t === n) throw D("Promise can't be resolved itself");
            var r = K(n);
            r
              ? O(function () {
                  var i = { done: !1 };
                  try {
                    r.call(n, nt(rt, t, i, e), nt(it, t, i, e));
                  } catch (n) {
                    it(t, i, n, e);
                  }
                })
              : ((e.value = n), (e.state = 1), J(t, e, !1));
          } catch (n) {
            it(t, { done: !1 }, n, e);
          }
        }
      };
    X &&
      ((M = function (t) {
        g(this, M, I), b(t), i.call(this);
        var e = R(this);
        try {
          t(nt(rt, this, e), nt(it, this, e));
        } catch (t) {
          it(this, e, t);
        }
      }),
      ((i = function (t) {
        V(this, {
          type: I,
          done: !1,
          notified: !1,
          parent: !1,
          reactions: [],
          rejection: !1,
          state: 0,
          value: void 0,
        });
      }).prototype = d(M.prototype, {
        then: function (t, e) {
          var n = F(this),
            i = U(k(this, M));
          return (
            (i.ok = 'function' != typeof t || t),
            (i.fail = 'function' == typeof e && e),
            (i.domain = W ? Q.domain : void 0),
            (n.parent = !0),
            n.reactions.push(i),
            0 != n.state && J(this, n, !1),
            i.promise
          );
        },
        catch: function (t) {
          return this.then(void 0, t);
        },
      })),
      (r = function () {
        var t = new i(),
          e = R(t);
        (this.promise = t),
          (this.resolve = nt(rt, t, e)),
          (this.reject = nt(it, t, e));
      }),
      (j.f = U =
        function (t) {
          return t === M || t === o ? new r(t) : G(t);
        }),
      c ||
        'function' != typeof f ||
        ((a = f.prototype.then),
        p(
          f.prototype,
          'then',
          function (t, e) {
            var n = this;
            return new M(function (t, e) {
              a.call(n, t, e);
            }).then(t, e);
          },
          { unsafe: !0 }
        ),
        'function' == typeof N &&
          s(
            { global: !0, enumerable: !0, forced: !0 },
            {
              fetch: function (t) {
                return T(M, N.apply(l, arguments));
              },
            }
          ))),
      s({ global: !0, wrap: !0, forced: X }, { Promise: M }),
      h(M, I, !1, !0),
      v(I),
      (o = u(I)),
      s(
        { target: I, stat: !0, forced: X },
        {
          reject: function (t) {
            var e = U(this);
            return e.reject.call(void 0, t), e.promise;
          },
        }
      ),
      s(
        { target: I, stat: !0, forced: c || X },
        {
          resolve: function (t) {
            return T(c && this === o ? M : this, t);
          },
        }
      ),
      s(
        { target: I, stat: !0, forced: z },
        {
          all: function (t) {
            var e = this,
              n = U(e),
              i = n.resolve,
              r = n.reject,
              o = E(function () {
                var n = b(e.resolve),
                  o = [],
                  a = 0,
                  s = 1;
                w(t, function (t) {
                  var c = a++,
                    l = !1;
                  o.push(void 0),
                    s++,
                    n.call(e, t).then(function (t) {
                      l || ((l = !0), (o[c] = t), --s || i(o));
                    }, r);
                }),
                  --s || i(o);
              });
            return o.error && r(o.value), n.promise;
          },
          race: function (t) {
            var e = this,
              n = U(e),
              i = n.reject,
              r = E(function () {
                var r = b(e.resolve);
                w(t, function (t) {
                  r.call(e, t).then(n.resolve, i);
                });
              });
            return r.error && i(r.value), n.promise;
          },
        }
      );
  },
  function (t, e, n) {
    var i = n(4),
      r = n(21),
      o = n(2)('species');
    t.exports = function (t, e) {
      var n,
        a = i(t).constructor;
      return void 0 === a || null == (n = i(a)[o]) ? e : r(n);
    };
  },
  function (t, e, n) {
    var i,
      r,
      o,
      a = n(0),
      s = n(1),
      c = n(11),
      l = n(62),
      u = n(81),
      f = n(53),
      p = n(105),
      d = a.location,
      h = a.setImmediate,
      v = a.clearImmediate,
      m = a.process,
      b = a.MessageChannel,
      g = a.Dispatch,
      y = 0,
      S = {},
      w = function (t) {
        if (S.hasOwnProperty(t)) {
          var e = S[t];
          delete S[t], e();
        }
      },
      C = function (t) {
        return function () {
          w(t);
        };
      },
      k = function (t) {
        w(t.data);
      },
      x = function (t) {
        a.postMessage(t + '', d.protocol + '//' + d.host);
      };
    (h && v) ||
      ((h = function (t) {
        for (var e = [], n = 1; arguments.length > n; ) e.push(arguments[n++]);
        return (
          (S[++y] = function () {
            ('function' == typeof t ? t : Function(t)).apply(void 0, e);
          }),
          i(y),
          y
        );
      }),
      (v = function (t) {
        delete S[t];
      }),
      'process' == c(m)
        ? (i = function (t) {
            m.nextTick(C(t));
          })
        : g && g.now
        ? (i = function (t) {
            g.now(C(t));
          })
        : b && !p
        ? ((o = (r = new b()).port2),
          (r.port1.onmessage = k),
          (i = l(o.postMessage, o, 1)))
        : !a.addEventListener ||
          'function' != typeof postMessage ||
          a.importScripts ||
          s(x)
        ? (i =
            'onreadystatechange' in f('script')
              ? function (t) {
                  u.appendChild(f('script')).onreadystatechange = function () {
                    u.removeChild(this), w(t);
                  };
                }
              : function (t) {
                  setTimeout(C(t), 0);
                })
        : ((i = x), a.addEventListener('message', k, !1))),
      (t.exports = { set: h, clear: v });
  },
  function (t, e, n) {
    var i = n(88);
    t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(i);
  },
  function (t, e, n) {
    'use strict';
    var i = n(21),
      r = function (t) {
        var e, n;
        (this.promise = new t(function (t, i) {
          if (void 0 !== e || void 0 !== n)
            throw TypeError('Bad Promise constructor');
          (e = t), (n = i);
        })),
          (this.resolve = i(e)),
          (this.reject = i(n));
      };
    t.exports.f = function (t) {
      return new r(t);
    };
  },
  function (t, e, n) {
    var i = n(108).default,
      r = n(118).default,
      o = n(139).default,
      a = n(16).default,
      s = n(70).default,
      c = n(147).default,
      l = !1,
      u = function () {
        if (!l) {
          if (
            ((l = !0),
            boostPFSConfig.general.isInitFilter || i.initWithoutFilter(),
            BoostPFS.Settings.getSettingValue('general.enableAjaxCart'))
          )
            if (
              (new a().refresh(),
              BoostPFS.Settings.getSettingValue(
                'general.enableAjaxCartOnProductPage'
              ))
            )
              new c().refresh();
          f(window);
        }
      },
      f = function (t) {
        (t.AddToCart = r),
          (t.QuickView = o),
          (t.AjaxCart = a),
          (t.OTPButtons = i),
          (t.AjaxCartItem = s),
          (t.AjaxCartOnProductPage = c);
      },
      p = {
        AddToCart: r,
        QuickView: o,
        AjaxCart: a,
        AjaxCartItem: s,
        AjaxCartOnProductPage: c,
        OTPButtons: i,
        init: u,
        reInit: function () {
          (l = !1), u();
        },
        inject: f,
      };
    t.exports = p;
  },
  function (t, e, n) {
    'use strict';
    n.r(e);
    n(17), n(15), n(83), n(84);
    var i = n(7),
      r = BoostPFS.Selector,
      o = BoostPFS.Settings,
      a = BoostPFS.Utils,
      s = function (t) {
        if (
          (o.getSettingValue('actionlist.atcEnable') &&
            ((t.addToCart = new BoostOTP.AddToCart()),
            t.addComponent(t.addToCart)),
          o.getSettingValue('actionlist.qvEnable') ||
            o.getSettingValue('general.enableAjaxCart'))
        ) {
          var e = !o.getSettingValue('actionlist.qvEnable');
          (t.quickView = new BoostOTP.QuickView(e)),
            t.addComponent(t.quickView);
        }
      },
      c = function (t) {
        if (
          (t.quickView && t.quickView.$element) ||
          (t.addToCart && t.addToCart.$element)
        ) {
          var e =
            '<div class="boost-pfs-action-list-wrapper boost-pfs-action-extend"></div>';
          r.otpButtons
            ? jQ(t.$element[0]).find(r.otpButtons).append(e)
            : jQ(t.$element[0]).append(e),
            t.$element.addClass('boost-pfs-action-list-enabled'),
            t.$element
              .find('img')
              .parent()
              .addClass('boost-pfs-action-overlay'),
            ((t.quickView && !t.addToCart) ||
              (t.addToCart && !t.quickView) ||
              (t.addToCart && t.quickView && t.quickView.isHidden)) &&
              t.$element.addClass('boost-pfs-action-list-single-button'),
            ((t.quickView && !t.addToCart) || (t.addToCart && !t.quickView)) &&
              t.$element.addClass('boost-pfs-action-list-single-button');
          var n = o.getSettingValue('actionlist.alStyle');
          ['bc-al-style3', 'bc-al-style4'].includes(n)
            ? (t.addToCart &&
                t.addToCart.$element &&
                t.$element
                  .find('.boost-pfs-action-list-wrapper')
                  .append(t.addToCart.$element),
              t.quickView &&
                t.quickView.$element &&
                t.$element
                  .find('.boost-pfs-action-list-wrapper')
                  .append(t.quickView.$element))
            : (t.quickView &&
                t.quickView.$element &&
                t.$element
                  .find('.boost-pfs-action-list-wrapper')
                  .append(t.quickView.$element),
              t.addToCart &&
                t.addToCart.$element &&
                t.$element
                  .find('.boost-pfs-action-list-wrapper')
                  .append(t.addToCart.$element)),
            t.hasOwnProperty('$productList') &&
              !t.$productList.hasClass(n) &&
              t.$productList.addClass(n);
        }
      },
      l = function (t) {
        if (
          t.$element &&
          t.$element.find('.boost-pfs-action-list-wrapper').length > 0
        )
          if (a.isMobile() || a.isTablet()) {
            jQ(window).on('load', function () {
              u(t);
            });
            var e = t.$element.find('img');
            e.length > 0 &&
              e.on('load', function () {
                setTimeout(function () {
                  u(t);
                }, 0);
              });
          } else
            u(t),
              t.$element.on('mouseenter', function () {
                u(t);
              });
      },
      u = function (t) {
        var e = t.$element.find('img'),
          n = t.$element.find('.boost-pfs-action-list-wrapper'),
          i =
            t.$element.outerWidth() -
            parseInt(t.$element.css('padding-left')) -
            parseInt(t.$element.css('padding-right'));
        if (e.length > 0 && n.length > 0) {
          var r = t.$element[0].getBoundingClientRect(),
            s = e[0].getBoundingClientRect(),
            c = n[0].getBoundingClientRect(),
            l = o.getSettingValue('actionlist.alStyle'),
            u = 0;
          if (
            (u =
              a.isMobile() ||
              a.isTablet() ||
              !['bc-al-style5', 'bc-al-style6'].includes(l)
                ? s.bottom - r.top - c.height
                : (s.bottom - r.top - c.height) / 2) <= 0
          )
            return;
          t.$element
            .find('.boost-pfs-action-list-wrapper')
            .css({ top: u + 'px', width: i + 'px', visibility: 'visible' });
        }
      },
      f = {
        initWithoutFilter: function () {
          if (r.otpProductItem) {
            var t = new i.a();
            (t.data = []),
              jQ(r.otpProductItem).each(function (e, n) {
                var r = new i.a();
                (r.$element = jQ(n)),
                  (r.$productList = r.$element.parent()),
                  (r.data = JSON.parse(
                    r.$element.find('.boost-pfs-product-data-json').html()
                  )),
                  (r.init = function () {
                    s(this);
                  }),
                  (r.render = function () {
                    c(this);
                  }),
                  (r.bindEvents = function () {
                    l(this);
                  }),
                  t.data.push(r.data),
                  t.addComponent(r);
              }),
              t.refresh();
          }
        },
        init: s,
        render: c,
        bindEvents: l,
        _calculateOTPPosition: u,
      };
    e.default = f;
  },
  function (t, e) {
    var n;
    n = (function () {
      return this;
    })();
    try {
      n = n || new Function('return this')();
    } catch (t) {
      'object' == typeof window && (n = window);
    }
    t.exports = n;
  },
  function (t, e, n) {
    var i = n(0),
      r = n(55),
      o = i.WeakMap;
    t.exports = 'function' == typeof o && /native code/.test(r(o));
  },
  function (t, e, n) {
    var i = n(13),
      r = n(58),
      o = n(61),
      a = n(4);
    t.exports =
      i('Reflect', 'ownKeys') ||
      function (t) {
        var e = r.f(a(t)),
          n = o.f;
        return n ? e.concat(n(t)) : e;
      };
  },
  function (t, e, n) {
    var i = n(8),
      r = n(9),
      o = n(4),
      a = n(65);
    t.exports = i
      ? Object.defineProperties
      : function (t, e) {
          o(t);
          for (var n, i = a(e), s = i.length, c = 0; s > c; )
            r.f(t, (n = i[c++]), e[n]);
          return t;
        };
  },
  function (t, e, n) {
    'use strict';
    var i = n(66),
      r = n(82);
    t.exports = i
      ? {}.toString
      : function () {
          return '[object ' + r(this) + ']';
        };
  },
  function (t, e, n) {
    var i = n(0),
      r = n(67).trim,
      o = n(44),
      a = i.parseInt,
      s = /^[+-]?0[Xx]/,
      c = 8 !== a(o + '08') || 22 !== a(o + '0x16');
    t.exports = c
      ? function (t, e) {
          var n = r(String(t));
          return a(n, e >>> 0 || (s.test(n) ? 16 : 10));
        }
      : a;
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(59).indexOf,
      o = n(85),
      a = n(22),
      s = [].indexOf,
      c = !!s && 1 / [1].indexOf(1, -0) < 0,
      l = o('indexOf'),
      u = a('indexOf', { ACCESSORS: !0, 1: 0 });
    i(
      { target: 'Array', proto: !0, forced: c || !l || !u },
      {
        indexOf: function (t) {
          return c
            ? s.apply(this, arguments) || 0
            : r(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    );
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(76),
      o = n(27),
      a = n(20),
      s = n(14),
      c = n(78),
      l = n(117),
      u = n(86),
      f = n(22),
      p = u('splice'),
      d = f('splice', { ACCESSORS: !0, 0: 0, 1: 2 }),
      h = Math.max,
      v = Math.min;
    i(
      { target: 'Array', proto: !0, forced: !p || !d },
      {
        splice: function (t, e) {
          var n,
            i,
            u,
            f,
            p,
            d,
            m = s(this),
            b = a(m.length),
            g = r(t, b),
            y = arguments.length;
          if (
            (0 === y
              ? (n = i = 0)
              : 1 === y
              ? ((n = 0), (i = b - g))
              : ((n = y - 2), (i = v(h(o(e), 0), b - g))),
            b + n - i > 9007199254740991)
          )
            throw TypeError('Maximum allowed length exceeded');
          for (u = c(m, i), f = 0; f < i; f++)
            (p = g + f) in m && l(u, f, m[p]);
          if (((u.length = i), n < i)) {
            for (f = g; f < b - i; f++)
              (d = f + n), (p = f + i) in m ? (m[d] = m[p]) : delete m[d];
            for (f = b; f > b - i + n; f--) delete m[f - 1];
          } else if (n > i)
            for (f = b - i; f > g; f--)
              (d = f + n - 1),
                (p = f + i - 1) in m ? (m[d] = m[p]) : delete m[d];
          for (f = 0; f < n; f++) m[f + g] = arguments[f + 2];
          return (m.length = b - i + n), u;
        },
      }
    );
  },
  function (t, e, n) {
    'use strict';
    var i = n(39),
      r = n(9),
      o = n(24);
    t.exports = function (t, e, n) {
      var a = i(e);
      a in t ? r.f(t, a, o(0, n)) : (t[a] = n);
    };
  },
  function (t, e, n) {
    'use strict';
    n.r(e);
    n(47),
      n(28),
      n(49),
      n(17),
      n(15),
      n(29),
      n(30),
      n(31),
      n(32),
      n(33),
      n(34),
      n(23),
      n(36),
      n(37);
    var i = n(7),
      r = n(16);
    function o(t) {
      return (o =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            })(t);
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError('Cannot call a class as a function');
    }
    function s(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function c(t, e) {
      return (c =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function l(t, e) {
      return !e || ('object' !== o(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t)
        : e;
    }
    function u(t) {
      return (u = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var f = BoostPFS.jQ,
      p = BoostPFS.Labels,
      d = BoostPFS.Utils,
      h = BoostPFS.Settings,
      v = (function (t) {
        !(function (t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError(
              'Super expression must either be null or a function'
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && c(t, e);
        })(v, t);
        var e,
          n,
          i,
          o = (function (t) {
            function e() {
              if ('undefined' == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ('function' == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = u(t);
              if (e()) {
                var r = u(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return l(this, n);
            };
          })(v);
        function v() {
          return a(this, v), o.apply(this, arguments);
        }
        return (
          (e = v),
          (i = [
            {
              key: 'Type',
              get: function () {
                return {
                  ADD_TO_CART: 'add-to-cart',
                  SOLD_OUT: 'sold-out',
                  SELECT_OPTIONS: 'select-options',
                };
              },
            },
          ]),
          (n = [
            {
              key: 'getTemplate',
              value: function () {
                return '\n\t\t\t<form method="post" action="/cart/add" accept-charset="UTF-8" class="{{class.atcForm}}" enctype="multipart/form-data" data-href="{{productUrl}}">\n\t\t\t\t<input type="hidden" name="form_type" value="product">\n\t\t\t\t<input type="hidden" name="quantity" value="1" min="1">\n\t\t\t\t<input type="hidden" name="id" value="{{variantId}}">\n\t\t\t\t<div class="boost-pfs-addtocart-wrapper">\n\t\t\t\t\t<button aria-label="{{label}}" name="add" class="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options" {{clickAction}}>\n\t\t\t\t\t\t<span> {{icoCart}}<span class="boost-pfs-addtocart-btn-text">{{label}}</span></span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t'.trim();
              },
            },
            {
              key: 'compileTemplate',
              value: function () {
                var t = d.buildProductItemUrl(this.parent.data),
                  e = '',
                  n = '',
                  i = '',
                  r = '',
                  o = this.parent.data,
                  a = this.parent.parent.data,
                  s = !1;
                Array.isArray(a)
                  ? (s = o.id == a[0].id)
                  : Array.isArray(a.products) && (s = o.id == a.products[0].id);
                var c = h.getSettingValue('general.icoCart'),
                  l = h.getSettingValue('general.icoCartLink');
                return (
                  o.available
                    ? 1 == o.variants.length
                      ? ((e = h.getSettingValue('general.enableAjaxCart')
                          ? ''
                          : 'type="submit"'),
                        (i = o.variants[0].id),
                        (n = p.action_list.atcAvailableLabel),
                        (r = Class.atcAvailable),
                        (this.type = v.Type.ADD_TO_CART),
                        (this.variantId = i))
                      : ((e = h.getSettingValue('general.enableAjaxCart')
                          ? ''
                          : 'onclick="window.location.href=\'' +
                            t +
                            '\'" type="button"'),
                        (n = p.action_list.atcSelectOptionsLabel),
                        (r = Class.atcSelectOptions),
                        (this.type = v.Type.SELECT_OPTIONS))
                    : ((e = 'disabled type="button"'),
                      (n = p.action_list.atcSoldOutLabel),
                      (r = Class.atcSoldOut),
                      (this.type = v.Type.SOLD_OUT)),
                  this.getTemplate()
                    .replace(/{{class.atcForm}}/g, Class.atcForm)
                    .replace(/{{label}}/g, n)
                    .replace(/{{variantId}}/g, i)
                    .replace(/{{clickAction}}/g, e)
                    .replace(/{{buttonClass}}/g, r)
                    .replace(/{{productUrl}}/g, t)
                    .replace(/{{icoCart}}/g, s ? c : l)
                );
              },
            },
            {
              key: 'render',
              value: function () {
                this.$element || (this.$element = f(this.compileTemplate()));
              },
            },
            {
              key: 'isBindEvents',
              value: function () {
                return h.getSettingValue('general.enableAjaxCart');
              },
            },
            {
              key: 'bindEvents',
              value: function () {
                if (this.$element)
                  switch (this.type) {
                    case v.Type.ADD_TO_CART:
                      this.$element.on(
                        'click',
                        this.onClickAddToCart.bind(this)
                      );
                      break;
                    case v.Type.SELECT_OPTIONS:
                      this.$element.on(
                        'click',
                        this.onClickOpenQuickView.bind(this)
                      );
                  }
              },
            },
            {
              key: 'onClickAddToCart',
              value: function (t) {
                t && t.preventDefault();
                var e = this.$element.find('.boost-pfs-addtocart-btn > span'),
                  n = this.parent.$element.find(
                    '.boost-pfs-addtocart-error-label'
                  );
                (n && 0 != n.length) ||
                  (this.parent.$element.append(
                    '<div class="boost-pfs-addtocart-error-label"></div>'
                  ),
                  (n = this.parent.$element.find(
                    '.boost-pfs-addtocart-error-label'
                  ))),
                  r.default.instance.addToCart(this.variantId, 1, e, n);
              },
            },
            {
              key: 'onClickOpenQuickView',
              value: function (t) {
                t && t.preventDefault(),
                  this.parent &&
                    this.parent.quickView &&
                    this.parent.quickView.$element &&
                    ((d.isMobile() ||
                      h.getSettingValue('general.selectOptionInProductItem')) &&
                      this.parent.quickView.$element.attr(
                        'data-get-quickview-option',
                        !0
                      ),
                    this.parent.quickView.$element.click());
              },
            },
          ]) && s(e.prototype, n),
          i && s(e, i),
          v
        );
      })(i.a);
    e.default = v;
  },
  function (t, e, n) {
    var i = n(1),
      r = n(44);
    t.exports = function (t) {
      return i(function () {
        return !!r[t]() || '​᠎' != '​᠎'[t]() || r[t].name !== t;
      });
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(1);
    function r(t, e) {
      return RegExp(t, e);
    }
    (e.UNSUPPORTED_Y = i(function () {
      var t = r('a', 'y');
      return (t.lastIndex = 2), null != t.exec('abcd');
    })),
      (e.BROKEN_CARET = i(function () {
        var t = r('^r', 'gy');
        return (t.lastIndex = 2), null != t.exec('str');
      }));
  },
  function (t, e, n) {
    var i = n(5);
    t.exports = function (t) {
      if (!i(t) && null !== t)
        throw TypeError("Can't set " + String(t) + ' as a prototype');
      return t;
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(21),
      r = n(5),
      o = [].slice,
      a = {},
      s = function (t, e, n) {
        if (!(e in a)) {
          for (var i = [], r = 0; r < e; r++) i[r] = 'a[' + r + ']';
          a[e] = Function('C,a', 'return new C(' + i.join(',') + ')');
        }
        return a[e](t, n);
      };
    t.exports =
      Function.bind ||
      function (t) {
        var e = i(this),
          n = o.call(arguments, 1),
          a = function () {
            var i = n.concat(o.call(arguments));
            return this instanceof a ? s(e, i.length, i) : e.apply(t, i);
          };
        return r(e.prototype) && (a.prototype = e.prototype), a;
      };
  },
  function (t, e, n) {
    var i = n(18),
      r = n(58).f,
      o = {}.toString,
      a =
        'object' == typeof window && window && Object.getOwnPropertyNames
          ? Object.getOwnPropertyNames(window)
          : [];
    t.exports.f = function (t) {
      return a && '[object Window]' == o.call(t)
        ? (function (t) {
            try {
              return r(t);
            } catch (t) {
              return a.slice();
            }
          })(t)
        : r(i(t));
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(101).IteratorPrototype,
      r = n(43),
      o = n(24),
      a = n(50),
      s = n(35),
      c = function () {
        return this;
      };
    t.exports = function (t, e, n) {
      var l = e + ' Iterator';
      return (
        (t.prototype = r(i, { next: o(1, n) })), a(t, l, !1, !0), (s[l] = c), t
      );
    };
  },
  function (t, e, n) {
    var i = n(0);
    t.exports = i.Promise;
  },
  function (t, e, n) {
    var i = n(12);
    t.exports = function (t, e, n) {
      for (var r in e) i(t, r, e[r], n);
      return t;
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(13),
      r = n(9),
      o = n(2),
      a = n(8),
      s = o('species');
    t.exports = function (t) {
      var e = i(t),
        n = r.f;
      a &&
        e &&
        !e[s] &&
        n(e, s, {
          configurable: !0,
          get: function () {
            return this;
          },
        });
    };
  },
  function (t, e) {
    t.exports = function (t, e, n) {
      if (!(t instanceof e))
        throw TypeError('Incorrect ' + (n ? n + ' ' : '') + 'invocation');
      return t;
    };
  },
  function (t, e, n) {
    var i = n(4),
      r = n(130),
      o = n(20),
      a = n(62),
      s = n(131),
      c = n(132),
      l = function (t, e) {
        (this.stopped = t), (this.result = e);
      };
    (t.exports = function (t, e, n, u, f) {
      var p,
        d,
        h,
        v,
        m,
        b,
        g,
        y = a(e, n, u ? 2 : 1);
      if (f) p = t;
      else {
        if ('function' != typeof (d = s(t)))
          throw TypeError('Target is not iterable');
        if (r(d)) {
          for (h = 0, v = o(t.length); v > h; h++)
            if ((m = u ? y(i((g = t[h]))[0], g[1]) : y(t[h])) && m instanceof l)
              return m;
          return new l(!1);
        }
        p = d.call(t);
      }
      for (b = p.next; !(g = b.call(p)).done; )
        if ('object' == typeof (m = c(p, y, g.value, u)) && m && m instanceof l)
          return m;
      return new l(!1);
    }).stop = function (t) {
      return new l(!0, t);
    };
  },
  function (t, e, n) {
    var i = n(2),
      r = n(35),
      o = i('iterator'),
      a = Array.prototype;
    t.exports = function (t) {
      return void 0 !== t && (r.Array === t || a[o] === t);
    };
  },
  function (t, e, n) {
    var i = n(82),
      r = n(35),
      o = n(2)('iterator');
    t.exports = function (t) {
      if (null != t) return t[o] || t['@@iterator'] || r[i(t)];
    };
  },
  function (t, e, n) {
    var i = n(4);
    t.exports = function (t, e, n, r) {
      try {
        return r ? e(i(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t.return;
        throw (void 0 !== o && i(o.call(t)), e);
      }
    };
  },
  function (t, e, n) {
    var i = n(2)('iterator'),
      r = !1;
    try {
      var o = 0,
        a = {
          next: function () {
            return { done: !!o++ };
          },
          return: function () {
            r = !0;
          },
        };
      (a[i] = function () {
        return this;
      }),
        Array.from(a, function () {
          throw 2;
        });
    } catch (t) {}
    t.exports = function (t, e) {
      if (!e && !r) return !1;
      var n = !1;
      try {
        var o = {};
        (o[i] = function () {
          return {
            next: function () {
              return { done: (n = !0) };
            },
          };
        }),
          t(o);
      } catch (t) {}
      return n;
    };
  },
  function (t, e, n) {
    var i,
      r,
      o,
      a,
      s,
      c,
      l,
      u,
      f = n(0),
      p = n(38).f,
      d = n(11),
      h = n(104).set,
      v = n(105),
      m = f.MutationObserver || f.WebKitMutationObserver,
      b = f.process,
      g = f.Promise,
      y = 'process' == d(b),
      S = p(f, 'queueMicrotask'),
      w = S && S.value;
    w ||
      ((i = function () {
        var t, e;
        for (y && (t = b.domain) && t.exit(); r; ) {
          (e = r.fn), (r = r.next);
          try {
            e();
          } catch (t) {
            throw (r ? a() : (o = void 0), t);
          }
        }
        (o = void 0), t && t.enter();
      }),
      y
        ? (a = function () {
            b.nextTick(i);
          })
        : m && !v
        ? ((s = !0),
          (c = document.createTextNode('')),
          new m(i).observe(c, { characterData: !0 }),
          (a = function () {
            c.data = s = !s;
          }))
        : g && g.resolve
        ? ((l = g.resolve(void 0)),
          (u = l.then),
          (a = function () {
            u.call(l, i);
          }))
        : (a = function () {
            h.call(f, i);
          })),
      (t.exports =
        w ||
        function (t) {
          var e = { fn: t, next: void 0 };
          o && (o.next = e), r || ((r = e), a()), (o = e);
        });
  },
  function (t, e, n) {
    var i = n(4),
      r = n(5),
      o = n(106);
    t.exports = function (t, e) {
      if ((i(t), r(e) && e.constructor === t)) return e;
      var n = o.f(t);
      return (0, n.resolve)(e), n.promise;
    };
  },
  function (t, e, n) {
    var i = n(0);
    t.exports = function (t, e) {
      var n = i.console;
      n && n.error && (1 === arguments.length ? n.error(t) : n.error(t, e));
    };
  },
  function (t, e) {
    t.exports = function (t) {
      try {
        return { error: !1, value: t() };
      } catch (t) {
        return { error: !0, value: t };
      }
    };
  },
  function (t, e, n) {
    'use strict';
    var i = n(12),
      r = n(4),
      o = n(1),
      a = n(91),
      s = RegExp.prototype,
      c = s.toString,
      l = o(function () {
        return '/a/b' != c.call({ source: 'a', flags: 'b' });
      }),
      u = 'toString' != c.name;
    (l || u) &&
      i(
        RegExp.prototype,
        'toString',
        function () {
          var t = r(this),
            e = String(t.source),
            n = t.flags;
          return (
            '/' +
            e +
            '/' +
            String(
              void 0 === n && t instanceof RegExp && !('flags' in s)
                ? a.call(t)
                : n
            )
          );
        },
        { unsafe: !0 }
      );
  },
  function (t, e, n) {
    'use strict';
    n.r(e);
    n(47),
      n(28),
      n(49),
      n(15),
      n(102),
      n(140),
      n(17),
      n(141),
      n(45),
      n(46),
      n(83),
      n(69),
      n(143),
      n(145),
      n(29),
      n(30),
      n(31),
      n(32),
      n(33),
      n(34),
      n(23),
      n(36),
      n(37);
    var i = n(7),
      r = n(16);
    function o(t) {
      return (o =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            })(t);
    }
    function a(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function s(t, e) {
      return (s =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function c(t, e) {
      return !e || ('object' !== o(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t)
        : e;
    }
    function l(t) {
      return (l = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var u = BoostPFS.Labels,
      f = BoostPFS.jQ,
      p = BoostPFS.Settings,
      d = BoostPFS.Utils,
      h = (function (t) {
        !(function (t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError(
              'Super expression must either be null or a function'
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && s(t, e);
        })(h, t);
        var e,
          n,
          i,
          o = (function (t) {
            function e() {
              if ('undefined' == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ('function' == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = l(t);
              if (e()) {
                var r = l(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return c(this, n);
            };
          })(h);
        function h(t) {
          var e;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw new TypeError('Cannot call a class as a function');
            })(this, h),
            ((e = o.call(this)).isHidden = t),
            e
          );
        }
        return (
          (e = h),
          (n = [
            {
              key: 'getTemplate',
              value: function () {
                return '\n\t\t\t<button class="boost-pfs-quickview-btn boost-pfs-filter-button" {{hiddenStyle}} data-href="{{productUrl}}" aria-label="{{label.quickview}}">\n\t\t\t\t<span>\n\t\t\t\t\t{{icoQuickView}}\n\t\t\t\t</span>\n\t\t\t</button>\n\t\t'.trim();
              },
            },
            {
              key: 'getModalTemplate',
              value: function () {
                return '\n\t\t\t<div class="boost-pfs-modal-backdrop">\n\t\t\t\t<div class="boost-pfs-modal-container">\n\t\t\t\t\t<div class="boost-pfs-modal-content"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'.trim();
              },
            },
            {
              key: 'getSelectOptionTemplate',
              value: function () {
                return '\n\t\t\t<div class="boost-pfs-select-option-wrapper">\n\t\t\t\t<button class="boost-pfs-filter-button boost-pfs-select-option-close" aria-label="{{labels.ada.closeQuickViewSelectOption}}"></button>\n\t\t\t\t{{modalHtml}}\n\t\t\t</div>\n\t\t'.trim();
              },
            },
            {
              key: 'compileTemplate',
              value: function () {
                var t = this.parent.data,
                  e = this.parent.parent.data,
                  n = !1;
                Array.isArray(e)
                  ? (n = t.id == e[0].id)
                  : Array.isArray(e.products) && (n = t.id == e.products[0].id);
                var i = p.getSettingValue('general.icoQuickView'),
                  r = p.getSettingValue('general.icoQuickViewLink');
                'bc-al-style6' == p.getSettingValue('actionlist.alStyle') &&
                  ((i = u.action_list.qvBtnLabel),
                  (r = u.action_list.qvBtnLabel));
                var o = d.buildProductItemUrlWithVariant(this.parent.data),
                  a = d.stripHtml(d.getParam('variant', o)),
                  s = o + ''.concat(a ? '&' : '?', 'view=boost-pfs-quickview');
                return this.getTemplate()
                  .replace(/{{label.quickview}}/g, u.action_list.qvBtnLabel)
                  .replace(/{{productUrl}}/g, s)
                  .replace(/{{icoQuickView}}/g, n ? i : r)
                  .replace(
                    /{{hiddenStyle}}/g,
                    this.isHidden ? 'style="display:none;"' : ''
                  );
              },
            },
            {
              key: 'render',
              value: function () {
                this.$element || (this.$element = f(this.compileTemplate()));
              },
            },
            {
              key: 'bindEvents',
              value: function () {
                this.$element &&
                  this.$element.on(
                    'click',
                    this.getQuickViewModalContent.bind(this)
                  );
              },
            },
            {
              key: 'getQuickViewModalContent',
              value: function (t) {
                var e = this;
                if (t) {
                  t.stopPropagation(), t.preventDefault();
                  var n = f(t.currentTarget).data('href');
                  d.isBadUrl(n) ||
                    ((this.isGetQuickViewOption = !!f(t.currentTarget).attr(
                      'data-get-quickview-option'
                    )),
                    f('.boost-pfs-select-option-wrapper').remove(),
                    f('.boost-pfs-select-option-show').removeClass(
                      'boost-pfs-select-option-show'
                    ),
                    this.isGetQuickViewOption
                      ? (f(t.currentTarget).removeAttr(
                          'data-get-quickview-option'
                        ),
                        (n += '-option'),
                        this.parent.$element.addClass(
                          'boost-pfs-select-option-show'
                        ),
                        f('body').addClass('boost-pfs-select-option-show-body'))
                      : (this.$element
                          .closest('.boost-pfs-action-list-wrapper')
                          .css('visibility', 'hidden'),
                        this.renderQuickViewBackdrop()),
                    fetch(n, {
                      method: 'GET',
                      headers: { 'Content-Type': 'text/html;charset=UTF-8' },
                    })
                      .then(function (t) {
                        return t.text();
                      })
                      .then(function (t) {
                        e.renderQuickViewModal(t), e.bindQuickViewModalEvents();
                      }),
                    boostPFS.filter &&
                      !this.isGetQuickViewOption &&
                      boostPFS.filter.filterLoadingIcon.setShow(!0));
                }
              },
            },
            {
              key: 'renderQuickViewBackdrop',
              value: function () {
                0 == f('.boost-pfs-modal-backdrop').length &&
                  (f('body').append(this.getModalTemplate()),
                  f('.boost-pfs-modal-backdrop').on(
                    'click',
                    this.closeModal.bind(this)
                  )),
                  f('.boost-pfs-modal-backdrop').show(),
                  f('.boost-pfs-modal-container').hide(),
                  f('body').addClass('boost-pfs-body-no-scroll-normal'),
                  f('html').addClass('boost-pfs-body-no-scroll-normal');
              },
            },
            {
              key: 'renderQuickViewModal',
              value: function (t) {
                boostPFS.filter &&
                  boostPFS.filter.filterLoadingIcon.setShow(!1);
                var e = '';
                if (
                  ((e = this.isGetQuickViewOption
                    ? t
                        .replace(
                          /^[\s\S]*<!\x2D\x2D Boost PFS Quickview Option \x2D\x2D>/gm,
                          ''
                        )
                        .replace(
                          /<!\x2D\x2D End Boost PFS Quickview Option \x2D\x2D>[\s\S]*$/gm,
                          ''
                        )
                        .replace('style="display: none!important;"', '')
                    : t
                        .replace(
                          /^[\s\S]*<!\x2D\x2D Boost PFS Quickview \x2D\x2D>/gm,
                          ''
                        )
                        .replace(
                          /<!\x2D\x2D End Boost PFS Quickview \x2D\x2D>[\s\S]*$/gm,
                          ''
                        )
                        .replace('style="display: none!important;"', '')),
                  this.isGetQuickViewOption)
                ) {
                  var n = this.parent.$element;
                  if (
                    (p.getSettingValue('general.selectOptionContainer') &&
                      (n = this.parent.$element.find(
                        p.getSettingValue('general.selectOptionContainer')
                      )),
                    n.length > 0)
                  ) {
                    n.find('.boost-pfs-select-option-wrapper').remove();
                    var i = this.getSelectOptionTemplate()
                      .replace(
                        /{{labels.ada.closeQuickViewSelectOption}}/g,
                        u.ada.closeQuickViewSelectOption
                      )
                      .replace(/{{modalHtml}}/g, e);
                    n.append(i),
                      n
                        .find('.boost-pfs-quickview-selector-wrapper')
                        .each(function (t, e) {
                          if (
                            f(e)
                              .find('.boost-pfs-swatch-element input')
                              .is(':checked')
                          ) {
                            var n = d.stripHtml(
                              f(e)
                                .find(
                                  '.boost-pfs-swatch-element input[checked="checked"]'
                                )
                                .val()
                            );
                            f(e)
                              .find(
                                '.boost-pfs-quickview-product-option-header .boost-pfs-quickview-product-option-header-select-option'
                              )
                              .html(n);
                          }
                          f(e)
                            .find('.boost-pfs-swatch-element input')
                            .click(function () {
                              f(e)
                                .find(
                                  '.boost-pfs-quickview-product-option-header .boost-pfs-quickview-product-option-header-select-option'
                                )
                                .html(d.stripHtml(f(this).val()));
                            });
                        });
                  }
                } else
                  f('.boost-pfs-modal-content').html(e),
                    f('.boost-pfs-modal-container').show();
              },
            },
            {
              key: 'bindQuickViewModalEvents',
              value: function () {
                f('.boost-pfs-swatch-element label').on(
                  'keydown',
                  function (t) {
                    !t.target ||
                      (13 != t.keyCode && 32 != t.keyCode) ||
                      f(t.target).click();
                  }
                ),
                  this.isGetQuickViewOption
                    ? (p.getSettingValue('general.enableAjaxCart') &&
                        this.parent.$element
                          .find(
                            '#boost-pfs-quickview-cart-form-' +
                              this.parent.data.id
                          )
                          .on('submit', this.onClickAddToCart.bind(this)),
                      f('.boost-pfs-select-option-close').on(
                        'click',
                        function () {
                          f('.boost-pfs-select-option-wrapper').hide(),
                            f('.boost-pfs-action-list-enabled').removeClass(
                              'boost-pfs-select-option-show'
                            ),
                            f('body').removeClass(
                              'boost-pfs-select-option-show-body'
                            );
                        }
                      ),
                      f('.boost-pfs-select-option-wrapper').on(
                        'click',
                        function (t) {
                          t.stopPropagation();
                        }
                      ),
                      f('body').on('click', function (t) {
                        f('.boost-pfs-select-option-wrapper').length > 0 &&
                          (f('.boost-pfs-select-option-wrapper').hide(),
                          f('.boost-pfs-action-list-enabled').removeClass(
                            'boost-pfs-select-option-show'
                          ),
                          f('body').removeClass(
                            'boost-pfs-select-option-show-body'
                          ));
                      }),
                      f(
                        '.boost-pfs-quickview-cart-btn, .boost-pfs-select-option-close'
                      ).on('keydown', this.trapFocus.bind(this)),
                      f('.boost-pfs-select-option-close').focus(),
                      f('.boost-pfs-quickview-select-option').on(
                        'change',
                        this.onChangeVariant.bind(this)
                      ),
                      this.onChangeVariant())
                    : (this.initImageSlider(),
                      f('.boost-pfs-quickview-close').on(
                        'click',
                        this.closeModal.bind(this)
                      ),
                      f('.boost-pfs-quickview-select-option').on(
                        'change',
                        this.onChangeVariant.bind(this)
                      ),
                      f('.boost-pfs-quickview-select-option-color').on(
                        'change',
                        this.onChangeVariant.bind(this)
                      ),
                      this.onChangeVariant(),
                      p.getSettingValue('general.enableAjaxCart') &&
                        f('#boost-pfs-quickview-cart-form').on(
                          'submit',
                          this.onClickAddToCart.bind(this)
                        ),
                      f(
                        '.boost-pfs-quickview-view-full, .boost-pfs-quickview-close'
                      ).on('keydown', this.trapFocus.bind(this)),
                      f('.boost-pfs-quickview-close').focus());
              },
            },
            {
              key: 'closeModal',
              value: function (t) {
                var e = this,
                  n = f(t.target);
                (n.hasClass('boost-pfs-modal-backdrop') ||
                  n.hasClass('boost-pfs-modal-container') ||
                  n.hasClass('boost-pfs-quickview-close')) &&
                  (f('.boost-pfs-modal-backdrop').hide(),
                  f('.boost-pfs-modal-container').hide(),
                  f('body').removeClass('boost-pfs-body-no-scroll-normal'),
                  f('html').removeClass('boost-pfs-body-no-scroll-normal'),
                  f('body').hasClass('boost-pfs-ada') &&
                    this.parent.$element &&
                    (this.parent.$element
                      .find('.boost-pfs-action-list-wrapper')
                      .css({ visibility: 'visible' }),
                    setTimeout(function () {
                      e.$element.focus();
                    }, 200)));
              },
            },
            {
              key: 'trapFocus',
              value: function (t) {
                if (t && 'Tab' == t.key && t.currentTarget) {
                  var e = f(t.currentTarget);
                  this.isGetQuickViewOption
                    ? t.shiftKey && e.hasClass('boost-pfs-select-option-close')
                      ? (t.preventDefault(),
                        f('.boost-pfs-quickview-cart-btn').focus())
                      : !t.shiftKey &&
                        e.hasClass('boost-pfs-quickview-cart-btn') &&
                        (t.preventDefault(),
                        f('.boost-pfs-select-option-close').focus())
                    : t.shiftKey && e.hasClass('boost-pfs-quickview-close')
                    ? (t.preventDefault(),
                      f('.boost-pfs-quickview-view-full').focus())
                    : !t.shiftKey &&
                      e.hasClass('boost-pfs-quickview-view-full') &&
                      (t.preventDefault(),
                      f('.boost-pfs-quickview-close').focus());
                }
              },
            },
            {
              key: 'initImageSlider',
              value: function () {
                var t = f('.boost-pfs-quickview-featured-image-wrapper'),
                  e = f('.boost-pfs-quickview-featured-image'),
                  n = f('.boost-pfs-quickview-slider-prev'),
                  i = f('.boost-pfs-quickview-slider-next'),
                  r = f('.boost-pfs-quickview-slider-dot');
                0 != t.length &&
                  0 != e.length &&
                  ((this.imageSlider = {
                    $itemsWrapper: t,
                    $prev: n,
                    $next: i,
                    $dots: r,
                    posX1: 0,
                    posX2: 0,
                    posInitial: 0,
                    posFinal: 0,
                    threshold: 50,
                    slidesLength: e.length,
                    slideSize: e[0].offsetWidth,
                    index: 0,
                    allowShift: !0,
                    isDragging: !1,
                  }),
                  0 == this.imageSlider.index &&
                    this.imageSlider.$prev.addClass('disabled'),
                  this.imageSlider.index == this.imageSlider.slidesLength - 1 &&
                    this.imageSlider.$next.addClass('disabled'),
                  this.imageSlider.$itemsWrapper.css('left', '0px'),
                  this.imageSlider.$dots.first().addClass('active'),
                  this.imageSlider.$itemsWrapper.on(
                    'mousedown',
                    this.dragStart.bind(this)
                  ),
                  f(document).off('mousemove'),
                  f(document).off('mouseup'),
                  f(document).on('mousemove', this.dragAction.bind(this)),
                  f(document).on('mouseup', this.dragEnd.bind(this)),
                  this.imageSlider.$prev.on(
                    'click',
                    this.shiftSlide.bind(this, null, -1)
                  ),
                  this.imageSlider.$next.on(
                    'click',
                    this.shiftSlide.bind(this, null, 1)
                  ),
                  this.imageSlider.$dots.on(
                    'click',
                    function (t) {
                      var e = f(t.currentTarget).data('index');
                      isNaN(e) || this.shiftSlide(e, null);
                    }.bind(this)
                  ));
              },
            },
            {
              key: 'dragStart',
              value: function (t) {
                (t = t || window.event).preventDefault(),
                  (this.imageSlider.posInitial =
                    this.imageSlider.$itemsWrapper[0].offsetLeft),
                  (this.imageSlider.posX1 = t.clientX),
                  (this.imageSlider.isDragging = !0);
              },
            },
            {
              key: 'dragAction',
              value: function (t) {
                if (this.imageSlider.isDragging) {
                  (t = t || window.event),
                    (this.imageSlider.posX2 =
                      this.imageSlider.posX1 - t.clientX),
                    (this.imageSlider.posX1 = t.clientX);
                  var e =
                      this.imageSlider.$itemsWrapper[0].offsetLeft -
                      this.imageSlider.posX2,
                    n = 0.2 * this.imageSlider.slideSize,
                    i =
                      -this.imageSlider.slideSize *
                      (this.imageSlider.slidesLength - 0.8);
                  e > n ? (e = n) : e < i && (e = i),
                    this.imageSlider.$itemsWrapper.css('left', e + 'px');
                }
              },
            },
            {
              key: 'dragEnd',
              value: function (t) {
                this.imageSlider.isDragging &&
                  ((this.imageSlider.isDragging = !1),
                  (this.imageSlider.posFinal =
                    this.imageSlider.$itemsWrapper[0].offsetLeft),
                  this.imageSlider.posFinal - this.imageSlider.posInitial <
                  -this.imageSlider.threshold
                    ? this.shiftSlide(null, 1)
                    : this.imageSlider.posFinal - this.imageSlider.posInitial >
                      this.imageSlider.threshold
                    ? this.shiftSlide(null, -1)
                    : this.imageSlider.$itemsWrapper.css(
                        'left',
                        this.imageSlider.posInitial + 'px'
                      ));
              },
            },
            {
              key: 'shiftSlide',
              value: function (t, e) {
                if (
                  (null == t && (t = this.imageSlider.index + e),
                  this.imageSlider.allowShift)
                ) {
                  var n,
                    i = this.imageSlider.$itemsWrapper.css('left');
                  t > -1 && t < this.imageSlider.slidesLength
                    ? ((n = -1 * t * this.imageSlider.slideSize + 'px'),
                      (this.imageSlider.index = t))
                    : (n =
                        -1 *
                          this.imageSlider.index *
                          this.imageSlider.slideSize +
                        'px'),
                    i != n &&
                      (0 == this.imageSlider.index
                        ? this.imageSlider.$prev.addClass('disabled')
                        : this.imageSlider.$prev.removeClass('disabled'),
                      this.imageSlider.index ==
                      this.imageSlider.slidesLength - 1
                        ? this.imageSlider.$next.addClass('disabled')
                        : this.imageSlider.$next.removeClass('disabled'),
                      this.imageSlider.$dots.removeClass('active'),
                      this.imageSlider.$dots
                        .eq(this.imageSlider.index)
                        .addClass('active'),
                      this.imageSlider.$itemsWrapper.addClass(
                        'boost-pfs-quickview-slider-shifting'
                      ),
                      this.imageSlider.$itemsWrapper.css('left', n),
                      (this.imageSlider.allowShift = !1),
                      setTimeout(this.afterShiftSlide.bind(this), 300));
                }
              },
            },
            {
              key: 'afterShiftSlide',
              value: function () {
                this.imageSlider.$itemsWrapper.removeClass(
                  'boost-pfs-quickview-slider-shifting'
                ),
                  (this.imageSlider.allowShift = !0);
              },
            },
            {
              key: 'onClickAddToCart',
              value: function (t) {
                t && t.preventDefault();
                var e = this._getSelectedVariant(),
                  n = 1,
                  i = null,
                  o = null;
                this.isGetQuickViewOption
                  ? ((i = f('.boost-pfs-quickview-cart-btn-text')),
                    (o = f(
                      '.boost-pfs-select-option-wrapper .boost-pfs-addtocart-error-label'
                    )))
                  : ((n = d.stripHtml(
                      f('#boost-pfs-quickview-cart-quantity').val()
                    )),
                    (i = f('#boost-pfs-quickview-cart-btn-text')),
                    (o = f('#boost-pfs-addtocart-error-label'))),
                  e && r.default.instance.addToCart(e.id, n, i, o, !0);
              },
            },
            {
              key: 'onChangeVariant',
              value: function () {
                var t = this._getSelectedVariant();
                if (this.isGetQuickViewOption) this._updateQuickViewOption(t);
                else if (
                  (this._updateQuickViewModal(t), null != t && t.image)
                ) {
                  var e = d
                    .optimizeImage(t.image, 'small')
                    .replace('https:', '')
                    .split('?')[0];
                  f(
                    '.boost-pfs-quickview-slider-dot[data-image^="' + e + '"]'
                  ).click();
                }
              },
            },
            {
              key: '_getSelectedVariant',
              value: function () {
                var t = ['option1', 'option2', 'option3'],
                  e = null;
                e = this.isGetQuickViewOption
                  ? f(
                      '#boost-pfs-quickview-cart-form-' + this.parent.data.id
                    ).serializeArray()
                  : f('#boost-pfs-quickview-cart-form').serializeArray();
                var n = [];
                e.forEach(function (e) {
                  t.includes(e.name) && n.push(e);
                });
                var i = [];
                i = this.isGetQuickViewOption
                  ? JSON.parse(
                      f(
                        '.boost-pfs-quickview-variants-data-' +
                          this.parent.data.id
                      ).html()
                    )
                  : JSON.parse(f('#boost-pfs-quickview-variants-data').html());
                var r = null;
                if (
                  (i.forEach(function (t) {
                    if (!r) {
                      var e = !0;
                      n.forEach(function (n) {
                        if (e) {
                          var i = t[n.name],
                            r = n.value;
                          null != i && null != r && i != r && (e = !1);
                        }
                      }),
                        e && (r = t);
                    }
                  }),
                  r &&
                    r.id &&
                    this.parent &&
                    this.parent.data &&
                    Array.isArray(this.parent.data.variants))
                ) {
                  var o = this.parent.data.variants.find(function (t) {
                    return t.id == r.id;
                  });
                  o && Object.assign(r, o);
                }
                return r;
              },
            },
            {
              key: '_updateQuickViewModal',
              value: function (t) {
                if (t) {
                  var e = f('#boost-pfs-quickview-variants-selector'),
                    n = f('.boost-pfs-quickview-price-wrapper'),
                    i = e.find('option[selected]'),
                    r = e.find('option[data-variant-id="' + t.id + '"]');
                  e.val(t.id),
                    i && i.removeAttr('selected'),
                    r && r.attr('selected', 'selected');
                  var o = r.data('current-price'),
                    a = r.data('was-price'),
                    s = r.data('current-price-without-currency');
                  s && 'string' == typeof s && (s = s.replace(/[ ,.]/g, ''));
                  var c = r.data('was-price-without-currency');
                  c && 'string' == typeof c && (c = c.replace(/[ ,.]/g, ''));
                  var l = !1;
                  s && c && (l = parseFloat(c) > parseFloat(s)),
                    l
                      ? (f('#boost-pfs-quickview-current-price').html(
                          d.stripHtml(o)
                        ),
                        f('#boost-pfs-quickview-was-price').html(
                          d.stripHtml(a)
                        ),
                        n.addClass('boost-pfs-quickview-price-on-sale'))
                      : (f('#boost-pfs-quickview-current-price').html(
                          d.stripHtml(o)
                        ),
                        f('#boost-pfs-quickview-was-price').html(''),
                        n.removeClass('boost-pfs-quickview-price-on-sale'));
                }
                var p = f('#boost-pfs-quickview-cart-btn'),
                  h = f('#boost-pfs-quickview-cart-btn-text');
                t && t.available
                  ? (p.removeAttr('disabled'),
                    h.html(u.action_list.qvAddToCartBtnLabel))
                  : (p.attr('disabled', 'disabled'),
                    h.html(u.action_list.qvSoldOutLabel));
              },
            },
            {
              key: '_updateQuickViewOption',
              value: function (t) {
                var e = this.parent.data,
                  n = f('#boost-pfs-quickview-variants-selector-' + e.id),
                  i = f('#boost-pfs-quickview-cart-btn-' + e.id),
                  r = f('#boost-pfs-quickview-cart-btn-text-' + e.id);
                t && t.available
                  ? (n.val(t.id),
                    i.removeAttr('disabled'),
                    r.html(u.action_list.qvAddToCartBtnLabel))
                  : (i.attr('disabled', 'disabled'),
                    r.html(u.action_list.qvSoldOutLabel));
              },
            },
          ]) && a(e.prototype, n),
          i && a(e, i),
          h
        );
      })(i.a);
    e.default = h;
  },
  function (t, e, n) {
    'use strict';
    var i = n(3),
      r = n(42).filter,
      o = n(86),
      a = n(22),
      s = o('filter'),
      c = a('filter');
    i(
      { target: 'Array', proto: !0, forced: !s || !c },
      {
        filter: function (t) {
          return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    );
  },
  function (t, e, n) {
    'use strict';
    var i = n(92),
      r = n(142),
      o = n(4),
      a = n(19),
      s = n(103),
      c = n(93),
      l = n(20),
      u = n(95),
      f = n(48),
      p = n(1),
      d = [].push,
      h = Math.min,
      v = !p(function () {
        return !RegExp(4294967295, 'y');
      });
    i(
      'split',
      2,
      function (t, e, n) {
        var i;
        return (
          (i =
            'c' == 'abbc'.split(/(b)*/)[1] ||
            4 != 'test'.split(/(?:)/, -1).length ||
            2 != 'ab'.split(/(?:ab)*/).length ||
            4 != '.'.split(/(.?)(.?)/).length ||
            '.'.split(/()()/).length > 1 ||
            ''.split(/.?/).length
              ? function (t, n) {
                  var i = String(a(this)),
                    o = void 0 === n ? 4294967295 : n >>> 0;
                  if (0 === o) return [];
                  if (void 0 === t) return [i];
                  if (!r(t)) return e.call(i, t, o);
                  for (
                    var s,
                      c,
                      l,
                      u = [],
                      p =
                        (t.ignoreCase ? 'i' : '') +
                        (t.multiline ? 'm' : '') +
                        (t.unicode ? 'u' : '') +
                        (t.sticky ? 'y' : ''),
                      h = 0,
                      v = new RegExp(t.source, p + 'g');
                    (s = f.call(v, i)) &&
                    !(
                      (c = v.lastIndex) > h &&
                      (u.push(i.slice(h, s.index)),
                      s.length > 1 &&
                        s.index < i.length &&
                        d.apply(u, s.slice(1)),
                      (l = s[0].length),
                      (h = c),
                      u.length >= o)
                    );

                  )
                    v.lastIndex === s.index && v.lastIndex++;
                  return (
                    h === i.length
                      ? (!l && v.test('')) || u.push('')
                      : u.push(i.slice(h)),
                    u.length > o ? u.slice(0, o) : u
                  );
                }
              : '0'.split(void 0, 0).length
              ? function (t, n) {
                  return void 0 === t && 0 === n ? [] : e.call(this, t, n);
                }
              : e),
          [
            function (e, n) {
              var r = a(this),
                o = null == e ? void 0 : e[t];
              return void 0 !== o ? o.call(e, r, n) : i.call(String(r), e, n);
            },
            function (t, r) {
              var a = n(i, t, this, r, i !== e);
              if (a.done) return a.value;
              var f = o(t),
                p = String(this),
                d = s(f, RegExp),
                m = f.unicode,
                b =
                  (f.ignoreCase ? 'i' : '') +
                  (f.multiline ? 'm' : '') +
                  (f.unicode ? 'u' : '') +
                  (v ? 'y' : 'g'),
                g = new d(v ? f : '^(?:' + f.source + ')', b),
                y = void 0 === r ? 4294967295 : r >>> 0;
              if (0 === y) return [];
              if (0 === p.length) return null === u(g, p) ? [p] : [];
              for (var S = 0, w = 0, C = []; w < p.length; ) {
                g.lastIndex = v ? w : 0;
                var k,
                  x = u(g, v ? p : p.slice(w));
                if (
                  null === x ||
                  (k = h(l(g.lastIndex + (v ? 0 : w)), p.length)) === S
                )
                  w = c(p, w, m);
                else {
                  if ((C.push(p.slice(S, w)), C.length === y)) return C;
                  for (var O = 1; O <= x.length - 1; O++)
                    if ((C.push(x[O]), C.length === y)) return C;
                  w = S = k;
                }
              }
              return C.push(p.slice(S)), C;
            },
          ]
        );
      },
      !v
    );
  },
  function (t, e, n) {
    var i = n(5),
      r = n(11),
      o = n(2)('match');
    t.exports = function (t) {
      var e;
      return i(t) && (void 0 !== (e = t[o]) ? !!e : 'RegExp' == r(t));
    };
  },
  function (t, e, n) {
    var i = n(3),
      r = n(144);
    i(
      { target: 'Object', stat: !0, forced: Object.assign !== r },
      { assign: r }
    );
  },
  function (t, e, n) {
    'use strict';
    var i = n(8),
      r = n(1),
      o = n(65),
      a = n(61),
      s = n(51),
      c = n(14),
      l = n(52),
      u = Object.assign,
      f = Object.defineProperty;
    t.exports =
      !u ||
      r(function () {
        if (
          i &&
          1 !==
            u(
              { b: 1 },
              u(
                f({}, 'a', {
                  enumerable: !0,
                  get: function () {
                    f(this, 'b', { value: 3, enumerable: !1 });
                  },
                }),
                { b: 2 }
              )
            ).b
        )
          return !0;
        var t = {},
          e = {},
          n = Symbol();
        return (
          (t[n] = 7),
          'abcdefghijklmnopqrst'.split('').forEach(function (t) {
            e[t] = t;
          }),
          7 != u({}, t)[n] || 'abcdefghijklmnopqrst' != o(u({}, e)).join('')
        );
      })
        ? function (t, e) {
            for (
              var n = c(t), r = arguments.length, u = 1, f = a.f, p = s.f;
              r > u;

            )
              for (
                var d,
                  h = l(arguments[u++]),
                  v = f ? o(h).concat(f(h)) : o(h),
                  m = v.length,
                  b = 0;
                m > b;

              )
                (d = v[b++]), (i && !p.call(h, d)) || (n[d] = h[d]);
            return n;
          }
        : u;
  },
  function (t, e, n) {
    var i = n(3),
      r = n(146);
    i({ global: !0, forced: parseFloat != r }, { parseFloat: r });
  },
  function (t, e, n) {
    var i = n(0),
      r = n(67).trim,
      o = n(44),
      a = i.parseFloat,
      s = 1 / a(o + '-0') != -1 / 0;
    t.exports = s
      ? function (t) {
          var e = r(String(t)),
            n = a(e);
          return 0 === n && '-' == e.charAt(0) ? -0 : n;
        }
      : a;
  },
  function (t, e, n) {
    'use strict';
    n.r(e);
    n(17),
      n(15),
      n(45),
      n(46),
      n(69),
      n(29),
      n(30),
      n(31),
      n(32),
      n(33),
      n(34),
      n(23),
      n(36),
      n(37);
    var i = n(7),
      r = n(16);
    function o(t) {
      return (o =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            })(t);
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError('Cannot call a class as a function');
    }
    function s(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function c(t, e) {
      return (c =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function l(t, e) {
      return !e || ('object' !== o(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t)
        : e;
    }
    function u(t) {
      return (u = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var f = BoostPFS.jQ,
      p = BoostPFS.Settings,
      d = BoostPFS.Selector,
      h = (function (t) {
        !(function (t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError(
              'Super expression must either be null or a function'
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && c(t, e);
        })(h, t);
        var e,
          n,
          i,
          o = (function (t) {
            function e() {
              if ('undefined' == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ('function' == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = u(t);
              if (e()) {
                var r = u(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return l(this, n);
            };
          })(h);
        function h() {
          return a(this, h), o.apply(this, arguments);
        }
        return (
          (e = h),
          (n = [
            {
              key: 'isRender',
              value: function () {
                return (
                  Utils.isProductPage() &&
                  p.getSettingValue('general.enableAjaxCartOnProductPage')
                );
              },
            },
            {
              key: 'render',
              value: function () {
                (this.$form = f(d.productPageAtcForm).first()),
                  (this.$button = f(d.productPageAtcButton).first()),
                  this.$form &&
                    this.$button &&
                    this.$form.length > 0 &&
                    this.$button.length > 0 &&
                    ((this.$addingLabel = this.$button.find('span')),
                    (this.$errorLabel = this.$button
                      .parent()
                      .find('.boost-pfs-addtocart-error-label')),
                    (this.$errorLabel && 0 != this.$errorLabel.length) ||
                      (f(
                        '<div class="boost-pfs-addtocart-error-label"></div>'
                      ).insertAfter(this.$button),
                      (this.$errorLabel = this.$button
                        .parent()
                        .find('.boost-pfs-addtocart-error-label'))));
              },
            },
            {
              key: 'bindEvents',
              value: function () {
                this.$form &&
                  this.$button &&
                  this.$form.length > 0 &&
                  this.$button.length > 0 &&
                  this.$button[0].addEventListener(
                    'click',
                    this.onClickAddToCart.bind(this),
                    !0
                  );
              },
            },
            {
              key: 'onClickAddToCart',
              value: function (t) {
                t && (t.stopPropagation(), t.preventDefault());
                var e = this.$form.serializeArray(),
                  n = 0,
                  i = 1;
                e.forEach(function (t) {
                  'id' == t.name
                    ? (n = t.value)
                    : 'quantity' == t.name && (i = t.value);
                }),
                  r.default.instance.addToCart(
                    n,
                    i,
                    this.$addingLabel,
                    this.$errorLabel
                  );
              },
            },
          ]) && s(e.prototype, n),
          i && s(e, i),
          h
        );
      })(i.a);
    e.default = h;
  },
]);
